import React, {
  useEffect,
  useState,
  useContext,
  useRef,
  useReducer,
} from "react";
import _ from "lodash";
import Select from "react-select";
import ConfirmationModal from "../project/ConfirmationModal";
import {
  Button,
  Input,
  UncontrolledTooltip,
  TabContent,
  TabPane,
} from "reactstrap";
import {
  getOrderItem,
  deletePartition,
  updatePartitionComponent,
  addEqualShelves,
  addEqualPartitions,
  addAbsoluteShelf,
  addAbsoluteVerticals,
  updateSpaceSize,
  clearSpace,
  updateShutter,
  copyInternalsToSpace,
  copyTemplateToSpace,
  removeShutter,
  addShutter,
  updateWallSize,
  updateWallName,
  deleteWall,
  deleteItems,
  mergeShutters,
  replaceModuleTemplate,
  updateOrderItemData,
} from "./service";
import {
  OptionImage,
  SpaceInfoButton,
  CloseButtonContainer,
  CloseButton,
} from "./style";
import {
  CustomizationSpinnerContainer,
  Notification,
  Icon,
  ActionIcon,
} from "../common/style";
import { AppContext } from "../context";
import { Spinner } from "reactstrap";
import { UI_RESTRICTED_PROPERTIES } from "../constants";
import {
  cloneItems,
  groupItems,
  unGroupItems,
  updateOrderItemProperties,
} from "../project/service";
import { getOrderItemCutlist } from "../product/service";
import { ProjectButton } from "../project/style";
import { Products, RoomCanvas, SectionCanvas } from ".";
import { Materials, ProjectSettingsModal } from ".";
import { Colors } from "../project/index";
import { InlineEdit } from "rsuite";
import { useOutletContext } from "react-router-dom";
import MultiUpdateModal from "../project/MultiUpdateModal";
import RightSideModal from "./RightSideModal";
import { ReactComponent as ModuleIcon } from "../assets/img/module.svg";
import ProjectImport from "../project/ProjectImport";
import NewOrder from "../order/NewOrder";
import LightForm from "./LightForm";

function NewPersonalize() {
  const {
    selectionManager,
    historyManager,
    currentSelection,
    setCurrentSelection,
    currentRoom,
    loadRoom,
    projectId,
    isLoading,
    setIsLoading,
    currentTab,
    setCurrentTab,
    isReset,
    setIsReset,
    getObjectKey,
    hoverItem,
    setHoverItem,
    isEq,
    finalisedContexts,
    isAdmin,
    isDesigner,
    isViewer,
    isOrderFinalised,
    isOrderDraft,
    access,
    loadProject,
    isCurrentTab,
    lightsList,
    projectSummary,
    refreshProjectSummary,
    version,
    isListProject,
    setRoom,
  } = useOutletContext();
  const [cutlists, setCutlist] = useState([]);
  const [projectSettings, setProjectSettings] = useState({});
  const [isNotificationVisible, setIsNotificationVisible] = useState(true);
  const [notificationMessage, setNotificationMessage] = useState({});
  const [isRightPaneLoading, setIsRightPaneLoading] = useState(false);
  const [isCutlist, setIsCutlist] = useState(false);
  const [partitionType, setPartitionType] = useState("");
  const [initialPartitionType, setInitialPartitionType] = useState("");
  const [changedProperty, setChangedProperty] = useState("");
  const [errorMessage, setErrorMessage] = useState("");
  const [modulesCategory, setModulesCategory] = useState("internal_submodule");
  const [showAddModule, setShowAddModule] = useState(false);
  const [removeOverrideConfirmationOpen, setRemoveOverrideConfirmationOpen] =
    useState(false);
  const [showDeleteWallConfirmation, setShowDeleteWallConfirmation] =
    useState(false);
  const [
    isRemoveShutterColorOverrideOpen,
    setIsRemoveShutterColorOverrideOpen,
  ] = useState(false);
  const [activePropertyTab, setActivePropertyTab] = useState("user");
  const { organizationData } = useContext(AppContext);
  const [shelfSelection, setShelfSelection] = useState(false);
  const [currentChange, setCurrentChange] = useState(null);
  const [currentOption, setCurrentOption] = useState(null);
  const [removable, setRemovable] = useState(false);
  const [shelfPosition, setShelfPosition] = useState("");
  const [shelfDirection, setShelfDirection] = useState("");
  const [disableSave, setDisableSave] = useState(false);
  const [height, setHeight] = useState("");
  const [width, setWidth] = useState("");
  const [inputEnabledHeight, setInputEnabledHeight] = useState(false);
  const [inputEnabledWidth, setInputEnabledWidth] = useState(false);
  const [shutterHeight, setShutterHeight] = useState("");
  const [shutterWidth, setShutterWidth] = useState("");
  const [shutterColor, setShutterColor] = useState({});
  const [shutterCNCType, setShutterCNCType] = useState(null);
  const [shutterPatternType, setShutterPatternType] = useState(null);
  const [clearDimension, setClearDimension] = useState("");
  const [removeShutterConfirmationOpen, setRemoveShutterConfirmationOpen] =
    useState(false);
  const [addShutterConfirmationOpen, setAddShutterConfirmationOpen] =
    useState(false);
  const [mergeShutterConfirmationOpen, setMergeShutterConfirmationOpen] =
    useState(false);
  const [showShutters, setShowShutters] = useState(true);
  const [orderItemName, setOrderItemName] = useState();
  const [activeOIInput, setActiveOIInput] = useState(null);
  const [showOIEditBox, setShowOIEditBox] = useState(false);
  const [orderItemUserLabel, setOrderItemUserLabel] = useState();
  const [wallName, setWallName] = useState();
  const [regenerateShuttersConfirmation, setRegenerateShuttersConfirmation] =
    useState(false);
  const [copyTemplateMethod, setCopyTemplateMethod] = useState(() => {});
  const [priceSummary, setPriceSummary] = useState(false);
  const [panelSummary, setPanelSummary] = useState(false);
  const [showItemsDeleteConfirmation, setShowItemsDeleteConfirmation] =
    useState(false);
  const selectionManagerRef = useRef(selectionManager);
  const isOrderFinalisedRef = useRef(isOrderFinalised);
  const [, forceUpdate] = useReducer((x) => x + 1, 0);
  const [position, setPosition] = useState({ x: 200, y: 200 });
  const [zoom, setZoom] = useState(0.5);
  const [showReplaceTemplate, setShowReplaceTemplate] = useState(false);
  const [showMessageOnTemplateChange, setShowMessageOnTemplateChange] =
    useState({
      show: false,
      message: "",
      args: {},
    });
  const [shrinkLeft, setShrinkLeft] = useState(0);
  const [shrinkRight, setShrinkRight] = useState(0);
  const [shrinkTop, setShrinkTop] = useState(0);
  const [shrinkBottom, setShrinkBottom] = useState(0);
  const [disabledDirections, setDisabledShrinkDirections] = useState([]);
  const [activeInput, setActiveInput] = useState("");
  const [invalidDimension, setInvalidDimension] = useState({
    height: "",
    width: "",
    depth: "",
  });
  const containerRef = useRef(null);
  const [showModal, setShowModal] = useState(false);
  const popover1Ref = useRef(null);
  const popover2Ref = useRef(null);
  const [currentPanelIdentifier, setCurrentPanelIdentifier] = useState(null);
  const [showLightForm, setShowLightForm] = useState(false);
  const [lightInfo, setLightInfo] = useState({});
  const [clearSpaceConfirmationOpen, setClearSpaceConfirmationOpen] =
    useState(false);
  const [removePartitionConfirmationOpen, setRemovePartitionConfirmationOpen] =
    useState(false);
  const [openLightGroove, setOpenLightGroove] = useState("");

  // Callbacks
  useEffect(() => {
    setShowReplaceTemplate(false);
    setShowLightForm(false);
    setLightInfo({});
    clearSpaceActionContext();
    clearShutterActionContext();
    setOpenLightGroove("");

    const selectedItem = selectionManager.selection();
    setInvalidDimension({ height: "", width: "", depth: "" });
    if (isNotificationVisible) onDismissNotification();

    if (selectedItem) {
      if (selectedItem.type == "space") {
        setHeight(selectedItem.dimensions.height);
        setWidth(selectedItem.dimensions.width);
      } else if (selectedItem.type == "shutter") {
        setShutterHeight(selectedItem.dimensions["height"]);
        setShutterWidth(selectedItem.dimensions["width"]);
        setShutterCNCType(selectedItem.cnc_type);
        setShutterPatternType(selectedItem.pattern_type);
        if (selectedItem.shrink_offset) {
          setShrinkBottom((selectedItem.shrink_offset["bottom"] || 0) * -1);
          setShrinkLeft((selectedItem.shrink_offset["left"] || 0) * -1);
          setShrinkRight((selectedItem.shrink_offset["right"] || 0) * -1);
          setShrinkTop((selectedItem.shrink_offset["top"] || 0) * -1);
          setDisabledShrinkDirections(
            selectedItem.shrink_offset["disabled_directions"] || []
          );
        }
        if (selectedItem.overrides) {
          let finalShutterColor = {};
          selectedItem.component.panels.map((panel, panelIndex) => {
            let panelIdentifier = panel.identifier;
            let value = selectedItem.overrides[panelIdentifier]
              ? selectedItem.overrides[panelIdentifier]["external_color"]
              : null;
            if (value)
              finalShutterColor = {
                ...finalShutterColor,
                [panelIdentifier]: value.slice(1, value.length - 1),
              };
          });
          setShutterColor(finalShutterColor);
        } else setShutterColor({});
        setInputEnabledHeight(false);
        setInputEnabledWidth(false);
      } else if (selectedItem.type == "partition") {
        setPartitionType(selectedItem.component.identifier);
        setInitialPartitionType(selectedItem.component.identifier);
      } else if (selectedItem.type == "wall") {
        setHeight(selectionManager.selectedWall().dimensions.height);
        setWidth(selectionManager.selectedWall().dimensions.width);
        setWallName(selectionManager.selectedWall().name);
      } else if (selectionManager.selectedModule()) {
        prepareForModuleEditing();
        setOrderItemName(selectionManager.selectedModule().name);
        setOrderItemUserLabel(selectionManager.selectedModule().user_label);
      }
    } else {
      if (isCurrentTab("info") && version == 1) {
        // No selection. Activate settings tab.
        setCurrentTab("settings");
      }
    }

    if (
      selectionManager.selections().length > 1 &&
      selectionManager.areSelectionsHomogenous("shutter")
    ) {
      let finalShutterColor = {};
      let shutterColorHash = {};
      selectionManager.selections().forEach((shutter, shutterIndex) => {
        shutter.component.panels.forEach((panel, panelIndex) => {
          let panelIdentifier = panel.identifier;
          if (!shutterColorHash[panelIdentifier]) {
            shutterColorHash[panelIdentifier] = [];
          }
          if (shutter.overrides && shutter.overrides[panelIdentifier])
            shutter.overrides && shutter.overrides[panelIdentifier]
              ? shutterColorHash[panelIdentifier].push(
                  shutter.overrides[panelIdentifier]["external_color"]
                )
              : shutterColorHash[panelIdentifier].push(null);
        });
      });

      Object.keys(shutterColorHash).forEach((panelIdentifier) => {
        const uniqueValues = [...new Set(shutterColorHash[panelIdentifier])];
        if (
          uniqueValues.length === 1 &&
          shutterColorHash[panelIdentifier][0] != null
        ) {
          finalShutterColor[panelIdentifier] = shutterColorHash[
            panelIdentifier
          ][0].slice(1, shutterColorHash[panelIdentifier][0].length - 1);
        }
      });
      setShutterColor(finalShutterColor);
    }
  }, [currentSelection]);

  useEffect(() => {
    setDisableSave(
      ["fixed_shelf", "fixed_vertical"].includes(currentOption)
        ? !/^([1-9]\d*)$/.test(shelfPosition)
        : invalidPosition(shelfPosition) || !currentChange || !currentOption
    );
  }, [currentChange, currentOption, shelfPosition]);

  useEffect(() => {
    currentOption === "fixed_shelf"
      ? setShelfDirection("top")
      : setShelfDirection("left");
  }, [currentOption]);

  // Partition type change
  useEffect(() => {
    const updatedFilteredOptions = options.filter((option) => {
      if (
        partitionType === "vertical_partition" ||
        partitionType === "vertical_partition_full_depth"
      ) {
        return (
          option.key === "vertical_partition" ||
          option.key === "vertical_partition_full_depth"
        );
      } else {
        return (
          option.key !== "vertical_partition" &&
          option.key !== "vertical_partition_full_depth"
        );
      }
    });
    setFilteredOptions(updatedFilteredOptions);
  }, [partitionType]);

  useEffect(() => {
    if (currentRoom) {
      for (const group of currentRoom.groups) {
        if (!group.temp_id) {
          for (const module of group.modules) {
            // Populate properties in editable format.
            populateGroupedProperties(module);
          }
        }
      }

      currentRoom.modules.forEach((module) =>
        populateGroupedProperties(module)
      );
    }
  }, [currentRoom, version]);

  useEffect(() => {
    if (currentRoom && isListProject) {
      if (version == 1) {
        setCurrentTab(
          selectionManager.selections().length > 0 ? "info" : "settings"
        );
      } else {
        const item =
          currentRoom.groups.length > 0
            ? currentRoom.groups[0]
            : currentRoom.modules.length > 0
            ? currentRoom.modules[0]
            : null;
        if (item) setCurrentSelection([item]);
        setCurrentTab("info");
      }
    }

    setPosition({ x: 200, y: 200 });
    setZoom(0.5);
  }, [version]);

  useEffect(() => {
    selectionManagerRef.current = selectionManager;
  }, [selectionManager]);

  useEffect(() => {
    isOrderFinalisedRef.current = isOrderFinalised;
  }, [isOrderFinalised]);

  useEffect(() => {
    window.addEventListener("keydown", handleKeyDown);

    return () => {
      window.removeEventListener("keydown", handleKeyDown);
    };
  }, []);

  useEffect(() => {
    if (currentPanelIdentifier) updateShutterConfig(currentPanelIdentifier);

    return () => setCurrentPanelIdentifier(null);
  }, [shutterColor, shutterCNCType, shutterPatternType]);

  const handleKeyDown = (event) => {
    // User is possibly working on an input element. Don't apply shortcut.
    if (event.target instanceof HTMLInputElement) return;
    if (event.target instanceof HTMLTextAreaElement) return;

    if (
      (event.key === "Delete" || event.key === "Backspace") &&
      selectionManagerRef.current.areSelectionsCanDelete() &&
      selectionManagerRef.current.selections().length > 0 &&
      !isOrderFinalisedRef.current &&
      access.customize_module
    ) {
      if (selectionManagerRef.current.selectedModule()?.is_filler) {
        alert(
          "Filler modules cannot be deleted. Change the fillers setting instead."
        );
      } else {
        setShowItemsDeleteConfirmation(true);
      }
    }

    if (
      (event.ctrlKey || event.metaKey) &&
      (event.key === "d" || event.key === "D") &&
      selectionManagerRef.current.canSelectionsClone() &&
      selectionManagerRef.current.selections().length > 0 &&
      !isOrderFinalisedRef.current
    ) {
      event.preventDefault();
      cloneSelectedItems();
    }
  };

  const toggleRemoveShutterConfirmation = () =>
    setRemoveShutterConfirmationOpen(!removeShutterConfirmationOpen);

  const toggleAddShutterConfirmation = () =>
    setAddShutterConfirmationOpen(!addShutterConfirmationOpen);

  const toggleMergeShutterConfirmation = () =>
    setMergeShutterConfirmationOpen(!mergeShutterConfirmationOpen);

  const toggleShowItemsDeleteConfirmation = () =>
    setShowItemsDeleteConfirmation(!showItemsDeleteConfirmation);

  const toggleOverrideConfirmation = () =>
    setRemoveOverrideConfirmationOpen(!removeOverrideConfirmationOpen);

  const toggleShowDeleteWallConfirmation = () => {
    setShowDeleteWallConfirmation(!showDeleteWallConfirmation);
  };

  const toggleLightGroove = (id) => {
    if (openLightGroove == id) setOpenLightGroove("");
    else setOpenLightGroove(id);
  };

  const handleWallNameUpdate = (value) => {
    updateWallName({
      projectId: projectId,
      wallId: selectionManager.selection().id,
      name: wallName,
    })
      .then((response) => {
        replaceWall(response);
      })
      .catch(({ error }) => {
        setNotificationMessage({
          text: error,
          type: "danger",
        });
      });
  };

  const handleWallDelete = () => {
    deleteWall({
      projectId: projectId,
      wallId: selectionManager.selection().id,
    });
    selectionManager.clear();
    selectionManager.triggerLoadRoom(currentRoom.id);
  };

  const toggleClearSpaceConfirmation = () => {
    setClearSpaceConfirmationOpen(!clearSpaceConfirmationOpen);
  };

  const handleCancelForUpdateWall = () => {
    setInputEnabledHeight(false);
    setInputEnabledWidth(false);
    selectionManager.clear();
  };

  const handleUpdateWall = () => {
    if (!height && !width) return;

    const wall = selectionManager.selectedWall();

    if (wall.group_id) {
      const group = selectionManager.findGroup(wall.group_id);
      wall.dimensions.height = parseInt(height);
      wall.dimensions.width = parseInt(width);

      group.dimensions = selectionManager.calculateGroupDimensions(
        group.modules.concat(group.walls)
      );
    }

    setIsRightPaneLoading(true);

    updateWallSize({
      projectId: projectId,
      wallId: selectionManager.selection().id,
      height: height !== "" ? parseInt(height) : null,
      width: width !== "" ? parseInt(width) : null,
    })
      .then((wall) => {
        replaceWall(wall);
      })
      .catch((error) => {
        if (error.response) {
          setHeight(selectionManager.selection().dimensions?.height);
          setWidth(selectionManager.selection().dimensions?.width);

          setIsNotificationVisible(true);
          setNotificationMessage({
            type: "danger",
            text: `Dimensions can't be updated. Please check .`,
          });
        } else {
          throw error;
        }
      })
      .finally(() => {
        setIsRightPaneLoading(false);
        setInputEnabledHeight(false);
        setInputEnabledWidth(false);
      });
  };

  const toggleRemovePartitionConfirmation = () => {
    setRemovePartitionConfirmationOpen(!removePartitionConfirmationOpen);
  };

  const toggleInputHeight = () => {
    setInputEnabledHeight(!inputEnabledHeight);
  };

  const toggleInputWidth = () => {
    setInputEnabledWidth(!inputEnabledWidth);
  };

  const handleHeightChange = (e) => {
    setHeight(e.target.value);
  };

  const handleWidthChange = (e) => {
    setWidth(e.target.value);
  };

  const onDismissNotification = () => {
    setIsNotificationVisible(false);
  };

  const handleCancelForUpdateSpace = () => {
    setInputEnabledHeight(false);
    setInputEnabledWidth(false);
    selectionManager.clear();
  };

  const handleCancelForUpdatePartition = () => {
    setPartitionType(initialPartitionType);
    selectionManager.clear();
  };

  const handleDeletePartition = () => {
    if (!selectionManager.selectedPartition()) return;

    setIsRightPaneLoading(true);
    const pathToDelete = selectionManager.selectedPartition().path;
    deletePartition({
      projectId,
      groupId: selectionManager.activeGroupId(),
      orderItemId: selectionManager.activeModuleId(),
      path: pathToDelete,
    })
      .then((template) => {
        replaceTemplate(template);
        selectionManager.select(selectionManager.activeModule());
        refreshProjectSummary();
      })
      .catch((error) => {
        console.error("Failed to delete partition:", error);
      })
      .finally(() => {
        setIsRightPaneLoading(false);
        toggleRemovePartitionConfirmation();
      });
  };

  const handleClearSpace = () => {
    setIsRightPaneLoading(true);
    const pathToDelete = selectionManager.selection().path;

    clearSpace({
      projectId,
      groupId: selectionManager.activeGroupId(),
      orderItemId: selectionManager.activeModuleId(),
      path: pathToDelete,
    })
      .then((template) => {
        replaceTemplate(template);
        refreshProjectSummary();
      })
      .catch((error) => {
        console.error("Failed to clear space:", error);
      })
      .finally(() => {
        setIsRightPaneLoading(false);
        toggleClearSpaceConfirmation();
      });
  };

  const handleUpdateSpace = () => {
    if (!height && !width) return;

    setIsRightPaneLoading(true);
    const pathToUpdate = selectionManager.selection().path;

    updateSpaceSize({
      projectId: projectId,
      groupId: selectionManager.activeGroupId(),
      orderItemId: selectionManager.activeModuleId(),
      path: pathToUpdate,
      height: height !== "" ? parseInt(height) : null,
      width: width !== "" ? parseInt(width) : null,
    })
      .then((template) => {
        replaceTemplate(template);
        refreshProjectSummary();
        setInputEnabledHeight(false);
        setInputEnabledWidth(false);
      })
      .catch((error) => {
        const changingDimensions = inputEnabledHeight ? "Height" : "Width";

        setHeight(selectionManager.selection().dimensions?.height);
        setWidth(selectionManager.selection().dimensions?.width);

        setIsNotificationVisible(true);
        setNotificationMessage({
          type: "danger",
          text: `${changingDimensions} can't be updated. Please check .`,
        });
      })
      .finally(() => {
        setIsRightPaneLoading(false);
        setInputEnabledHeight(false);
        setInputEnabledWidth(false);
      });
  };

  const handleUpdatePartition = (updatedPartition) => {
    if (!selectionManager.selectedPartition() || !updatedPartition) return;

    setIsRightPaneLoading(true);
    const pathToUpdate = selectionManager.selectedPartition().path;
    updatePartitionComponent({
      projectId,
      groupId: selectionManager.activeGroupId(),
      orderItemId: selectionManager.activeModuleId(),
      path: pathToUpdate,
      componentIdentifier: updatedPartition,
    })
      .then((template) => {
        replaceTemplate(template);
        refreshProjectSummary();
      })
      .catch((error) => {
        console.error("Failed to update partition:", error);
      })
      .finally(() => {
        setIsRightPaneLoading(false);
      });
  };

  const orderItemCutlist = () => {
    setIsRightPaneLoading(true);

    return getOrderItemCutlist({
      orderItemId: selectionManager.activeModuleId(),
      projectId,
      groupId: selectionManager.activeGroupId(),
    })
      .then((cutlist) => {
        setCutlist(Object.values(cutlist).flat());
      })
      .catch(({ error }) => {
        setIsNotificationVisible(true);
        setNotificationMessage({ type: "error", message: error });
      })
      .finally(() => {
        setIsRightPaneLoading(false);
      });
  };

  const replaceGroup = (updatedGroup) => {
    let group = selectionManager.findGroup(updatedGroup.id);

    Object.assign(group, updatedGroup);
  };

  const replaceModule = (updatedModule) => {
    populateGroupedProperties(updatedModule);
    const module = selectionManager.findModule(updatedModule.id);

    // Overwrite the module using the new one.
    Object.assign(module, updatedModule);
    forceUpdate();
  };

  const replaceTemplate = (template) => {
    if (selectionManager.areSelectionsHomogenous("shutter")) {
      replaceModule({
        ...selectionManager.findModule(
          selectionManager.selections()[0].order_item_id
        ),
        template: template,
      });
    } else {
      replaceModule({ ...selectionManager.activeModule(), template: template });
    }

    if (selectionManager.selectedSpace()) {
      selectionManager.select(
        selectionManager.findSpace(
          selectionManager.selectedSpace().path,
          selectionManager.activeModuleId()
        )
      );
    } else if (selectionManager.selectedPartition()) {
      selectionManager.select(
        selectionManager.findPartition(
          selectionManager.selectedPartition().path,
          selectionManager.activeModuleId()
        )
      );
    } else if (selectionManager.areSelectionsHomogenous("shutter")) {
      const shutters = selectionManager
        .selections()
        .map((s) =>
          template.shutters.find((e) => e.sequence_number == s.sequence_number)
        )
        .filter((e) => e);
      setCurrentSelection(shutters);
    }
  };

  const replaceWall = (updatedWall) => {
    const wall = selectionManager.findWall(updatedWall.id);
    Object.assign(wall, updatedWall);
  };

  const populateGroupedProperties = (orderItem) => {
    if (orderItem.is_old_mode || orderItem.temp_id) return;

    if (!orderItem.isPrepared) {
      const groupedProperties = _.groupBy(
        orderItem.property_list.filter(
          (property) =>
            !(
              UI_RESTRICTED_PROPERTIES.includes(property.uniq_id) ||
              orderItem.project_settings[property.uniq_id]
            )
        ),
        "header_name"
      );

      orderItem.groupedProperties = groupedProperties;
      orderItem.isPrepared = true;
    }

    setProjectSettings({ ...orderItem.project_settings });
  };

  const prepareForModuleEditing = () => {
    const orderItem = selectionManager.selectedModule();
    setProjectSettings({ ...orderItem.project_settings });
  };

  const reloadModule = () => {
    setIsRightPaneLoading(true);

    getOrderItem({
      projectId,
      groupId: selectionManager.activeGroupId(),
      orderItemId: selectionManager.activeModuleId(),
      version: "v2",
    })
      .then((orderItem) => {
        replaceModule(orderItem);
      })
      .catch(({ error }) => {
        setNotificationMessage({ type: "danger", text: error });
      })
      .finally((_) => {
        setIsRightPaneLoading(false);
      });
  };

  const getSelectedItems = () => {
    let selectedItems = [];

    if (selectionManager.areSelectionsGroups()) {
      let selectedGroups = selectionManager.selections();

      selectedGroups.forEach((group) => {
        if (group.modules.length > 0) {
          selectedItems = selectedItems.concat(group.modules);
        }
      });
    }

    if (selectionManager.areSelectionsModules()) {
      let selectedModules = selectionManager.selections();

      if (selectedModules.length > 0) {
        selectedItems = selectedItems.concat(selectedModules);
      }
    }

    if (selectionManager.selectedGroup()) {
      let selectedGroup = selectionManager.selection();

      if (selectedGroup && selectedGroup.modules.length > 0) {
        selectedItems = selectedItems.concat(selectedGroup.modules);
      }
    }

    if (selectionManager.areSelectionsGroupsAndModules()) {
      let finalSelectedItems = [];
      const selections = selectionManager.selections();
      const hasGroups = selections.some((item) => item.type === "group");
      const hasModules = selections.some((item) => item.type === "module");

      if (hasGroups) {
        const selectedGroups = selections.filter(
          (item) => item.type === "group"
        );

        selectedGroups.forEach((group) => {
          if (group.modules.length > 0) {
            finalSelectedItems = finalSelectedItems.concat(group.modules);
          }
        });
      }

      if (hasModules) {
        const selectedModules = selections.filter(
          (item) => item.type === "module"
        );

        if (selectedModules.length > 0) {
          finalSelectedItems = finalSelectedItems.concat(selectedModules);
        }
      }

      selectedItems = selectedItems.concat(finalSelectedItems);
    }

    const uniqueItems = [
      ...new Map(selectedItems.map((item) => [item.id, item])).values(),
    ];

    return uniqueItems;
  };

  const handleCutlistClick = () => {
    setIsCutlist(true);
    orderItemCutlist();
  };

  const clearSpaceActionContext = () => {
    setRemovable(null);
    setShelfSelection(null);
    setCurrentOption(null);
    setCurrentChange(null);
  };

  const clearShutterActionContext = () => {
    setInputEnabledHeight(false);
    setInputEnabledWidth(false);
  };

  const handleCopyTemplate = (productId, onlyInternals = true) => {
    const copyTemplateCache = () => {
      handleSpaceAction(
        onlyInternals ? copyInternalsToSpace : copyTemplateToSpace,
        {
          projectId,
          groupId: selectionManager.activeGroupId(),
          orderItemId: selectionManager.activeModuleId(),
          path:
            selectionManager.selection().replaceable_space_path ||
            selectionManager.selection().path,
          productId,
        }
      );
    };

    if (selectionManager.selectedSpace().is_shuttered && !onlyInternals) {
      setCopyTemplateMethod(() => copyTemplateCache);
      setRegenerateShuttersConfirmation(true);

      return;
    }

    copyTemplateCache();
  };

  const addShelves = () => {
    if (currentChange === "shelves" && currentOption !== "fixed_shelf")
      handleSpaceAction(addEqualShelves, {
        projectId,
        groupId: selectionManager.activeGroupId(),
        orderItemId: selectionManager.activeModuleId(),
        shelfCount: parseInt(currentOption.replace("shelf_", "")),
        path: selectionManager.selection().path,
        removable,
      });
    else if (currentChange === "shelves")
      handleSpaceAction(addAbsoluteShelf, {
        projectId,
        groupId: selectionManager.activeGroupId(),
        orderItemId: selectionManager.activeModuleId(),
        position: parseInt(shelfPosition),
        path: selectionManager.selection().path,
        removable,
        direction: shelfDirection,
      });
    else if (
      currentChange === "verticals" &&
      currentOption !== "fixed_vertical"
    )
      handleSpaceAction(addEqualPartitions, {
        projectId,
        groupId: selectionManager.activeGroupId(),
        orderItemId: selectionManager.activeModuleId(),
        verticalCount: parseInt(currentOption.replace("vertical_", "")),
        path: selectionManager.selection().path,
      });
    else {
      handleSpaceAction(addAbsoluteVerticals, {
        projectId,
        groupId: selectionManager.activeGroupId(),
        orderItemId: selectionManager.activeModuleId(),
        position: parseInt(shelfPosition),
        path: selectionManager.selection().path,
        direction: shelfDirection,
      });
    }
  };

  const handleSpaceAction = (actionFn, payload) => {
    setIsRightPaneLoading(true);
    actionFn(payload)
      .then((template) => {
        replaceTemplate(template);
        clearSpaceActionContext();
        refreshProjectSummary();
      })
      .catch(({ error }) => {
        setIsNotificationVisible(true);
        setNotificationMessage({ type: "danger", text: error });
      })
      .finally(() => setIsRightPaneLoading(false));
  };

  const invalidPosition = (value) => {
    return !/^(|[1-9]\d*)$/.test(value);
  };

  const actions = [
    { label: "Add Shelves", value: "shelves" },
    { label: "Add Verticals", value: "verticals" },
  ];

  const options = [
    { key: "fixed_shelf", value: "Fixed Shelf" },
    { key: "fixed_shelf_full_depth", value: "Shutter Partition" },
    { key: "removable_shelf", value: "Removable Shelf" },
    { key: "vertical_partition", value: "Vertical Partition" },
    {
      key: "vertical_partition_full_depth",
      value: "Vertical Partition Full Depth",
    },
  ];

  const [filteredOptions, setFilteredOptions] = useState(options);

  const actions_options = {
    shelves: [
      { label: "Add 1 Shelf (eq)", value: "shelf_1" },
      { label: "Add 2 Shelves (eq)", value: "shelf_2" },
      { label: "Add 3 Shelves (eq)", value: "shelf_3" },
      { label: "Add 4 Shelves (eq)", value: "shelf_4" },
      { label: "Add 5 Shelves (eq)", value: "shelf_5" },
      { label: "Add 1 Shelf at fixed position", value: "fixed_shelf" },
    ],
    verticals: [
      { label: "Add 1 Partition (eq)", value: "vertical_1" },
      { label: "Add 2 Partition (eq)", value: "vertical_2" },
      { label: "Add 3 Partition (eq)", value: "vertical_3" },
      { label: "Add 4 Partition (eq)", value: "vertical_4" },
      { label: "Add 5 Partition (eq)", value: "vertical_5" },
      { label: "Add 1 Partition at fixed position", value: "fixed_vertical" },
    ],
  };

  const invalidShutterDimensions = (value) => {
    return !/^([1-9]\d*)$/.test(value);
  };

  const updateShutterConfig = (panelIdentifier = null) => {
    let payload = {
      items: [
        {
          sequence_number: selectionManager.selectedShutter().sequence_number,
          panel_identifier:
            panelIdentifier ||
            selectionManager.selectedShutter().component.panels[0].identifier,
        },
      ],
    };

    if (clearDimension) payload[clearDimension] = "";
    else {
      if (
        selectionManager.selectedShutter().dimensions["height"] != shutterHeight
      )
        payload.height = parseInt(shutterHeight);
      if (
        selectionManager.selectedShutter().dimensions["width"] != shutterWidth
      )
        payload.width = parseInt(shutterWidth);
      if (
        selectionManager.selectedShutter().overrides[panelIdentifier]?.[
          "external_color"
        ] != `'${shutterColor[panelIdentifier]}'`
      )
        payload.color = shutterColor[panelIdentifier];
      if (selectionManager.selectedShutter().cnc_type != shutterCNCType)
        payload.cnc_type = shutterCNCType;
      if (selectionManager.selectedShutter().pattern_type != shutterPatternType)
        payload.pattern_type = shutterPatternType;
      if (selectionManager.selectedShutter().shrink_offset) {
        payload.shrink_offset = {
          left: shrinkLeft !== null ? shrinkLeft * -1 : null,
          right: shrinkRight !== null ? shrinkRight * -1 : null,
          top: shrinkTop !== null ? shrinkTop * -1 : null,
          bottom: shrinkBottom !== null ? shrinkBottom * -1 : null,}
      };
    }

    handleShutterAction(updateShutter, payload, clearDimension);
  };

  const handleUpdateOrderItemData = () => {
    console.log("UPDATING WITH ", orderItemName, orderItemUserLabel);
    updateOrderItemData({
      projectId,
      groupId: selectionManager.activeGroupId(),
      orderItemId: selectionManager.activeModuleId(),
      orderItemName,
      orderItemUserLabel,
    })
      .catch(({ error }) => {
        setNotificationMessage({
          text: error,
          type: "danger",
        });
      })
      .finally(() => {
        reloadModule();
        setShowOIEditBox(false);
      });
  };

  const OrderItemNameComponent = ({
    orderItemName,
    setOrderItemName,
    orderItemUserLabel,
    setOrderItemUserLabel,
    showOIEditBox,
    setShowOIEditBox,
    handleUpdateOrderItemData,
    activeOIInput,
    setActiveOIInput,
    access,
  }) => {
    const nameInputRef = useRef(null);
    const labelInputRef = useRef(null);

    // Keeps focus on the active input, because for some reason it loses context whenever a character it typed.
    // Probably because the setOrderItemName/Label triggers a re-render of this scope?
    useEffect(() => {
      if (showOIEditBox) {
        if (activeOIInput === "name" && nameInputRef.current) {
          nameInputRef.current.focus();
        } else if (activeOIInput === "label" && labelInputRef.current) {
          labelInputRef.current.focus();
        }
      }
    }, [orderItemName, orderItemUserLabel]);

    const handleEditClick = () => {
      setShowOIEditBox(!showOIEditBox);
    };

    return (
      <div className="position-relative" style={{ overflow: "visible" }}>
        <div className="d-flex flex-row align-items-center">
          <div className="fs-14px fw-bold mb-0 me-2">{orderItemName}</div>
          {access.update_module && (
            <i
              className="far fa-edit fs-14px pointer"
              onClick={handleEditClick}
            />
          )}
        </div>

        {showOIEditBox && access.update_module && (
          <div
            className="position-absolute z-3 bg-white p-3 border rounded shadow mb-0 me-2"
            style={{
              top: `30px`,
              left: `0px`,
              width: "270px",
            }}
          >
            <span className="ms-1 mb-3 fs-15px fw-bold">Name:</span>
            <input
              ref={nameInputRef}
              type="text"
              value={orderItemName}
              className="form-control mb-12px"
              onFocus={() => {
                setActiveOIInput("name");
              }}
              onChange={(e) => setOrderItemName(e.target.value)}
            />

            <span className="ms-1 mb-3 fs-15px fw-bold">Label:</span>
            <input
              ref={labelInputRef}
              type="text"
              value={orderItemUserLabel}
              className="form-control w-25"
              onFocus={() => {
                setActiveOIInput("label");
              }}
              maxLength={4}
              onChange={(e) => setOrderItemUserLabel(e.target.value)}
            />

            <span className={"fs-12px text-secondary mb-12px"}>
              If left blank, this will be auto-generated
            </span>

            <button
              className="btn btn-primary me-2"
              onClick={handleUpdateOrderItemData}
            >
              Save
            </button>
            <button
              className="btn btn-secondary"
              onClick={() => setShowOIEditBox(false)}
            >
              Close
            </button>
          </div>
        )}
      </div>
    );
  };

  const getBorderColor = (value) => (value !== 0 ? "#2C51E6" : "#999999");

  const updateShuttersConfig = (color, panelIdentifier = null) => {
    if (selectionManager.areSelectionsHomogenous("shutter")) {
      let payload = {
        items: selectionManager.selections().map((e) => ({
          sequence_number: e.sequence_number,
          panel_identifier: panelIdentifier || e.component.panels[0].identifier,
        })),
      };
      if (clearDimension) payload[clearDimension] = "";
      else payload["color"] = color;
      handleShutterAction(updateShutter, payload, clearDimension);
    }
  };

  const handleShutterAction = (actionFn, payload) => {
    setIsRightPaneLoading(true);
    const module = selectionManager.findModule(
      selectionManager.selections()[0].order_item_id
    );

    actionFn({
      projectId,
      groupId: module.group_id,
      orderItemId: module.id,
      payload,
    })
      .then((template) => {
        replaceTemplate(template);

        if (clearDimension) {
          setClearDimension("");
          clearDimension == "height" &&
            setShutterHeight(updatedShutter.dimensions["height"]);
          clearDimension == "width" &&
            setShutterWidth(updatedShutter.dimensions["width"]);
          clearDimension == "color" && setShutterColor({});
        } else {
          setInputEnabledHeight(false);
          setInputEnabledWidth(false);
        }

        refreshProjectSummary();
      })
      .catch(({ error }) => {
        setIsNotificationVisible(true);
        setNotificationMessage({ type: "danger", text: error });
      })
      .finally(() => setIsRightPaneLoading(false));
  };

  const removeSelectedShutter = () => {
    const payload = {
      sequence_number: selectionManager.selectedShutter().sequence_number,
      panel_identifier: selectionManager.selectedShutter().identifier,
    };

    setIsRightPaneLoading(true);
    removeShutter({
      projectId,
      groupId: selectionManager.activeGroupId(),
      orderItemId: selectionManager.activeModuleId(),
      payload,
    })
      .then((template) => {
        replaceTemplate(template);
        selectionManager.clear();
        toggleRemoveShutterConfirmation();
        refreshProjectSummary();
      })
      .catch(({ error }) => {
        setIsNotificationVisible(true);
        setNotificationMessage({ type: "danger", text: error });
      })
      .finally(() => setIsRightPaneLoading(false));
  };

  const addRemovedShutter = () => {
    const payload = {
      sequence_number: selectionManager.selectedShutter().sequence_number,
      panel_identifier: selectionManager.selectedShutter().identifier,
    };

    setIsRightPaneLoading(true);
    addShutter({
      projectId,
      groupId: selectionManager.activeGroupId(),
      orderItemId: selectionManager.activeModuleId(),
      payload,
    })
      .then((template) => {
        replaceTemplate(template);
        toggleAddShutterConfirmation();
        refreshProjectSummary();
      })
      .catch(({ error }) => {
        setIsNotificationVisible(true);
        setNotificationMessage({ type: "danger", text: error });
      })
      .finally(() => setIsRightPaneLoading(false));
  };

  const updateProperties = ({
    orderItemIds,
    properties,
    dimensions,
    carcassExtensions,
  }) => {
    setIsRightPaneLoading(true);

    return updateOrderItemProperties({
      orderItemIds,
      properties,
      projectId: projectId,
      dimensions,
      carcassExtensions,
    })
      .then((orderItems) => {
        orderItems.forEach((o) => replaceModule(o));
        refreshProjectSummary();
        setErrorMessage("");
        setChangedProperty("");
      })
      .catch(({ error, property }) => {
        let invalidFields = [];

        if (Array.isArray(error)) {
          if (error.includes("Width invalid")) invalidFields.push("Width");
          if (error.includes("Height invalid")) invalidFields.push("Height");
          if (error.includes("Depth invalid")) invalidFields.push("Depth");
        }

        let errorMessage = invalidFields.length
          ? `Change ${invalidFields.join(", ")} and try again.`
          : error;
        const changedPropertyKey = property ? Object.keys(property)[0] : null;
        setErrorMessage(errorMessage);
        setChangedProperty(changedPropertyKey);
        if (dimensions)
          setInvalidDimension({
            ...invalidDimension,
            ...dimensions,
          });
        if (!errorMessage) setIsNotificationVisible(true);
        setNotificationMessage({ type: "danger", text: error });
      })
      .finally((_) => {
        setIsRightPaneLoading(false);
      });
  };

  const deleteSelectedItems = (items) => {
    selectionManager.removeItems(items);

    if (isListProject && items[0].type === "module" && items[0].is_packed)
      selectionManager.select(selectionManager.findGroup(items[0].group_id));

    deleteItems({
      projectId: projectId,
      roomId: currentRoom.id,
      items: items.map(({ type, id }) => ({
        type,
        id,
      })),
    })
      .then((room) => {
        setRoom(room);
        refreshProjectSummary();
      })
      .catch(({ error }) => {
        setIsNotificationVisible(true);
        setNotificationMessage({
          text: error,
          type: "danger",
        });
      });
  };

  const mergeSelectedShutter = () => {
    const payload = {
      sequence_number: selectionManager
        .selections()
        .map((e) => e.sequence_number),
    };
    const module = selectionManager.findModule(
      selectionManager.selections()[0].order_item_id
    );

    setIsRightPaneLoading(true);
    mergeShutters({
      projectId,
      groupId: module.group_id,
      orderItemId: module.id,
      payload,
    })
      .then((template) => {
        replaceTemplate(template);
        refreshProjectSummary();
      })
      .catch(({ error }) => {
        setIsNotificationVisible(true);
        setNotificationMessage({ type: "danger", text: error });
      })
      .finally(() => setIsRightPaneLoading(false));
  };

  const groupSelectedItems = () => {
    setIsLoading(true);

    return groupItems({
      projectId: projectId,
      roomId: currentRoom.id,
      payload: {
        items: selectionManager.selections().map(({ type, id }) => ({
          type,
          id,
        })),
      },
    })
      .then(({ group }) => {
        const mapper = {
          wall: ["walls", selectionManager.findWall],
          module: ["modules", selectionManager.findModule],
        };
        const isNewGroup =
          selectionManager.selections().filter((e) => e.type === "group")
            .length !== 1;
        const newGroup = isNewGroup
          ? {
              id: group.id,
              name: group.name,
              type: "group",
              modules: [],
              walls: [],
            }
          : selectionManager.findGroup(
              selectionManager.selections().find((e) => e.type === "group").id
            );
        let position = isNewGroup ? 1 : newGroup.modules.count + 1;

        selectionManager.selections().forEach((item) => {
          if (item.type === "group" && isNewGroup) {
            const groupModules = item.modules || [];
            const groupWalls = item.walls || [];

            groupModules.forEach((m) => {
              m.group_id = newGroup.id;
              m.sort_position = position;
              position += 1;
            });
            groupWalls.forEach((w) => (w.group_id = newGroup.id));

            newGroup.modules = newGroup.modules.concat(groupModules);
            newGroup.walls = newGroup.walls.concat(groupWalls);

            const index = currentRoom.groups.findIndex((g) => g.id == item.id);
            currentRoom.groups.splice(index, 1);
          } else if (["wall", "module"].includes(item.type)) {
            item.group_id = newGroup.id;
            const mapped = mapper[item.type];

            const object = mapped[1](item.id);

            if (item.type === "module") {
              object.sort_position = position;
              position += 1;
            }

            const index = currentRoom[mapped[0]].findIndex(
              (i) => i.id == item.id
            );
            newGroup[mapped[0]] = (newGroup[mapped[0]] || []).concat(object);
            currentRoom[mapped[0]].splice(index, 1);
          }
        });

        const children = (newGroup.modules || []).concat(newGroup.walls || []);

        newGroup.position = selectionManager.calculateGroupPosition(children);
        newGroup.dimensions =
          selectionManager.calculateGroupDimensions(children);
        newGroup.category = "BasicGroup";

        if (isNewGroup)
          currentRoom.groups = currentRoom.groups.concat(newGroup);

        selectionManager.select(newGroup);
      })
      .catch(({ error }) => {
        setIsNotificationVisible(true);
        setNotificationMessage({ type: "danger", text: error });
      })
      .finally(() => setIsLoading(false));
  };

  const unGroupSelectedItems = () => {
    let selections = [];

    selectionManager.selections().forEach((i) => {
      const index = currentRoom.groups.findIndex((g) => g.id == i.id);
      const modules =
        currentRoom.groups.find((g) => g.id == i.id).modules || [];
      const walls = currentRoom.groups.find((g) => g.id == i.id).walls || [];

      modules.forEach((e) => {
        e.group_id = null;
        e.sort_position = 0;
      });

      walls.forEach((e) => (e.group_id = null));

      currentRoom.modules = currentRoom.modules.concat(modules);
      currentRoom.walls = currentRoom.walls.concat(walls);
      currentRoom.groups.splice(index, 1);

      selections = selections.concat(modules);
    });

    setCurrentSelection(selections);

    return unGroupItems({
      projectId: projectId,
      roomId: currentRoom.id,
      groupIds: selectionManager.selections().map((e) => e.id),
    }).catch(({ error }) => {
      setIsNotificationVisible(true);
      setNotificationMessage({ type: "danger", text: error });
    });
  };

  const cloneSelectedItems = () => {
    if (isOrderFinalisedRef.current) return;

    setIsLoading(true);

    return cloneItems({
      projectId: projectId,
      roomId: currentRoom.id,
      items: selectionManagerRef.current.selections().map(({ type, id }) => ({
        type,
        id,
      })),
    })
      .then((response) => {
        selectionManager.triggerLoadRoom(
          selectionManagerRef.current.currentRoom().id,
          null,
          response.clone_items
        );
      })
      .catch(({ error }) => {
        setIsNotificationVisible(true);
        setNotificationMessage({ type: "danger", text: error });
      })
      .finally(() => setIsLoading(false));
  };

  const changeModuleTemplate = ({ projectId, orderItemId, productId }) => {
    setIsRightPaneLoading(true);

    replaceModuleTemplate({
      projectId,
      orderItemId,
      productId,
    })
      .then((orderItem) => {
        replaceModule(orderItem);
        selectionManager.select(selectionManager.findModule(orderItem.id));
        setShowReplaceTemplate(false);
        refreshProjectSummary();
      })
      .catch(({ error }) => {
        setIsNotificationVisible(true);
        setNotificationMessage({ type: "danger", text: error });
      })
      .finally(() => setIsRightPaneLoading(false));
  };

  const changeTemplate = ({
    projectId,
    orderItemId,
    productId,
    dimensionsRange,
  }) => {
    const dimensions = selectionManager.activeModule().dimensions;
    const notFittableDimensions = [];
    let message = "";

    ["Height", "Width", "Depth"].forEach((e) => {
      const dimension = e.toLowerCase();

      if (
        !(
          dimensionsRange[`min_${dimension}`] <= dimensions[dimension] &&
          dimensions[dimension] <= dimensionsRange[`max_${dimension}`]
        )
      )
        notFittableDimensions.push(e);
    });

    if (notFittableDimensions.length === 3) message = "The size";
    else if (notFittableDimensions.length === 2)
      message = `${notFittableDimensions[0]} and ${notFittableDimensions[1]}`;
    else if (notFittableDimensions.length === 1)
      message = `${notFittableDimensions[0]}`;
    else {
      changeModuleTemplate({ projectId, orderItemId, productId });
      return;
    }

    message +=
      " will be changed after this change. Are you sure you want to proceed?";
    setShowMessageOnTemplateChange({
      show: true,
      message: message,
      args: {
        projectId: projectId,
        orderItemId: orderItemId,
        productId: productId,
      },
    });
  };

  return !currentRoom ? (
    <div className="position-relative">
      <CustomizationSpinnerContainer top="200px" left="40%">
        <Spinner />
      </CustomizationSpinnerContainer>
    </div>
  ) : (
    <>
      {notificationMessage.text && (
        <Notification
          color={notificationMessage.type}
          isOpen={isNotificationVisible}
          toggle={onDismissNotification}
        >
          {notificationMessage.text}
        </Notification>
      )}
      {version == 1 ? (
        <div className="d-flex fh render-canvas">
          <div className="fh flex-grow-1 position-relative">
            {currentRoom && (
              <RoomCanvas
                selectionManager={selectionManager}
                historyManager={historyManager}
                currentRoom={currentRoom}
                showShutters={showShutters}
                setShowShutters={setShowShutters}
                notificationMessage={notificationMessage}
                projectId={projectId}
                loadRoom={loadRoom}
                isLoading={isLoading}
                isReset={isReset}
                setIsReset={setIsReset}
                position={position}
                setPosition={setPosition}
                zoom={zoom}
                setZoom={setZoom}
                getObjectKey={getObjectKey}
                hoverItem={hoverItem}
                setHoverItem={setHoverItem}
                isEq={isEq}
                access={access}
                containerRef={containerRef}
                setCurrentTab={setCurrentTab}
                version={version}
              />
            )}
          </div>
          <div
            className={`right-pane fh position-relative overflow-hidden ${
              (["catalog", "materials", "project_import", "order"].includes(
                currentTab
              ) ||
                showReplaceTemplate) &&
              "wide"
            }`}
          >
            {isCurrentTab("project_import") ? (
              <ProjectImport
                loadProject={loadProject}
                setCurrentTab={setCurrentTab}
              />
            ) : (
              <>
                {!isCurrentTab("info") && (
                  <div className="d-flex column-gap-3 align-items-center px-3 py-2 border-bottom right-pane-tabs">
                    <div
                      className={`tab-item pointer d-flex flex-column align-items-center row-gap-1 ${
                        isCurrentTab("catalog") && "active"
                      }`}
                      onClick={() => setCurrentTab("catalog")}
                    >
                      <ModuleIcon className="icon" />
                      <p className="m-0 fs-11px">Catalog</p>
                    </div>
                    <div
                      className={`tab-item pointer d-flex flex-column align-items-center row-gap-1 ${
                        isCurrentTab("settings") && "active"
                      }`}
                      onClick={() => setCurrentTab("settings")}
                    >
                      <i className="fa-solid fa-gear fs-6"></i>
                      <p className="m-0 fs-11px">Settings</p>
                    </div>
                    <div
                      className={`tab-item pointer d-flex flex-column align-items-center row-gap-1 ${
                        isCurrentTab("colors") && "active"
                      }`}
                      onClick={() => setCurrentTab("colors")}
                    >
                      <i className="fa-solid fa-palette fs-6"></i>
                      <p className="m-0 fs-11px">Colors</p>
                    </div>
                    <div
                      className={`tab-item pointer d-flex flex-column align-items-center row-gap-1 ${
                        isCurrentTab("order") && "active"
                      }`}
                      onClick={() => setCurrentTab("order")}
                    >
                      <i className="fa-solid fa-shopping-cart fs-6"></i>
                      <p className="m-0 fs-11px">Order</p>
                    </div>
                  </div>
                )}
                <div className={`fh ${isRightPaneLoading ? "blurred" : ""}`}>
                  {isCurrentTab("colors") ? (
                    <Colors
                      currentRoom={currentRoom}
                      loadRoom={loadRoom}
                      access={access}
                    />
                  ) : isCurrentTab("catalog") ? (
                    <>
                      <TabContent activeTab="1" className="mx-2">
                        <TabPane tabId="1">
                          <Products
                            isCurrentTab={isCurrentTab}
                            setCurrentTab={setCurrentTab}
                            setIsRightPaneLoading={setIsRightPaneLoading}
                            position={position}
                            zoom={zoom}
                            containerRef={containerRef}
                            access={access}
                          />
                        </TabPane>
                      </TabContent>
                    </>
                  ) : isCurrentTab("materials") ? (
                    <Materials
                      currentRoom={currentRoom}
                      loadRoom={loadRoom}
                      access={access}
                      finalisedContexts={finalisedContexts}
                    />
                  ) : isCurrentTab("settings") ? (
                    <>
                      {isAdmin && (
                        <div className="d-flex px-1 border-bottom">
                          <p
                            className={`m-0 p-2 tab ${
                              activePropertyTab === "user" ? "active" : ""
                            } me-2`}
                            onClick={() => setActivePropertyTab("user")}
                          >
                            User
                          </p>
                          <p
                            className={`m-0 p-2 tab ${
                              activePropertyTab === "admin" ? "active" : ""
                            }`}
                            onClick={() => setActivePropertyTab("admin")}
                          >
                            Admin
                          </p>
                        </div>
                      )}
                      <ProjectSettingsModal
                        currentRoom={currentRoom}
                        loadRoom={loadRoom}
                        access={access}
                        isDesigner={isDesigner}
                        isViewer={isViewer}
                        activePropertyTab={activePropertyTab}
                        is_order_finalised={isOrderFinalised}
                        isOrderDraft={isOrderDraft}
                        finalisedContexts={finalisedContexts}
                        isListProject={isListProject}
                      />
                    </>
                  ) : isCurrentTab("order") ? (
                    <NewOrder
                      isAdmin={isAdmin}
                      isDesigner={isDesigner}
                      currentRoom={currentRoom}
                      loadRoom={loadRoom}
                    />
                  ) : showLightForm ? (
                    <>
                      <LightForm
                        projectId={projectId}
                        orderItemId={selectionManager.selectedModule().id}
                        lightInfo={lightInfo}
                        setShowLightForm={setShowLightForm}
                        lightsList={lightsList}
                        loadRoom={loadRoom}
                        currentRoom={currentRoom}
                        replaceModule={replaceModule}
                        refreshProjectSummary={refreshProjectSummary}
                      />
                    </>
                  ) : shelfSelection ? (
                    <div>
                      <div className="d-flex align-items-center border-bottom p-3">
                        <i
                          onClick={() => {
                            clearSpaceActionContext();
                          }}
                          className="fa-solid fa-arrow-left fs-6 pointer"
                        />
                        <p className="fw-bold fs-14px m-0 ms-3">Partitions</p>
                      </div>
                      <div className="p-4 border-bottom">
                        <Select
                          options={actions}
                          value={actions.find((e) => e.value === currentChange)}
                          onChange={(option) => {
                            setCurrentChange(option.value);
                            setCurrentOption(null);
                          }}
                          placeholder="Select a change"
                        />
                      </div>
                      {currentChange && (
                        <div className="p-4 border-bottom">
                          <Select
                            options={actions_options[currentChange]}
                            value={
                              actions_options[currentChange].find(
                                (e) => e.value === currentOption
                              ) || null
                            }
                            onChange={(option) => {
                              setCurrentOption(option.value);
                              setShelfPosition("");
                            }}
                            placeholder="Select a option"
                          />
                        </div>
                      )}
                      {currentOption &&
                        ![
                          "vertical_1",
                          "vertical_2",
                          "vertical_3",
                          "vertical_4",
                          "vertical_5",
                        ].includes(currentOption) && (
                          <div className="p-4 border-bottom">
                            <div className="d-flex column-gap-3">
                              {(currentOption == "fixed_shelf" ||
                                currentOption == "fixed_vertical") && (
                                <>
                                  <div className="d-flex align-items-center column-gap-2">
                                    <Input
                                      value={shelfPosition}
                                      style={{ width: "70px" }}
                                      type="text"
                                      onChange={(ev) =>
                                        setShelfPosition(ev.target.value)
                                      }
                                      invalid={invalidPosition(shelfPosition)}
                                    />
                                    <span className="text-body-tertiary">
                                      mm
                                    </span>
                                  </div>
                                  <div className="d-flex align-items-center column-gap-2">
                                    <span className="fw-semibold">from</span>

                                    <Input
                                      value={shelfDirection}
                                      onChange={(event) =>
                                        setShelfDirection(event.target.value)
                                      }
                                      style={{ width: "80px" }}
                                      type="select"
                                    >
                                      {currentChange === "shelves" ? (
                                        <>
                                          <option value="top">top</option>
                                          <option value="bottom">bottom</option>
                                        </>
                                      ) : (
                                        <>
                                          <option value="left">left</option>
                                          <option value="right">right</option>
                                        </>
                                      )}
                                    </Input>
                                  </div>
                                </>
                              )}
                              {currentChange === "shelves" && (
                                <div className="d-flex align-items-center column-gap-2">
                                  <Input
                                    className="m-0"
                                    onChange={() => setRemovable(!removable)}
                                    type="checkbox"
                                    checked={removable}
                                  />
                                  <span className="fw-semibold">Removable</span>
                                </div>
                              )}
                            </div>
                          </div>
                        )}
                      <div className="d-flex p-4 column-gap-3">
                        <ProjectButton
                          onClick={() => addShelves()}
                          className="rounded-1"
                          disabled={disableSave}
                        >
                          Add Partition
                        </ProjectButton>

                        <Button
                          onClick={() => {
                            clearSpaceActionContext();
                          }}
                          className="rounded-1"
                          outline
                        >
                          Cancel
                        </Button>
                      </div>
                    </div>
                  ) : selectionManager.selectedSpace() ? (
                    <>
                      <div className="info-header">
                        <div className="d-flex align-items-center">
                          <i
                            onClick={() => {
                              selectionManager.clear();
                            }}
                            className="fa-solid fa-arrow-left fs-6 pointer"
                          />
                          <p className="fw-bold fs-14px m-0 ms-2">Space</p>
                        </div>
                        {selectionManager.selectedSpace().is_leaf_space &&
                        !selectionManager.selectedSpace().is_drawer ? (
                          <SpaceInfoButton
                            onClick={() => setShelfSelection(true)}
                            className="rounded-2"
                            color="#2C92E6"
                            size="sm"
                            disabled={
                              finalisedContexts.includes("carcass") ||
                              !access.customize_module
                            }
                          >
                            <i className="fa-solid fa-circle-plus me-2"></i>
                            Add Partitions
                          </SpaceInfoButton>
                        ) : (
                          selectionManager.selectedSpace().can_be_cleared && (
                            <SpaceInfoButton
                              className="rounded-2"
                              color="#dc3545"
                              outline
                              size="sm"
                              onClick={toggleClearSpaceConfirmation}
                              disabled={
                                finalisedContexts.includes("carcass") ||
                                finalisedContexts.includes("shutter") ||
                                !access.customize_module
                              }
                            >
                              <i className="fa-regular fa-trash-can me-2"></i>
                              Clear
                            </SpaceInfoButton>
                          )
                        )}
                      </div>
                      <div className="p-3 pb-0">
                        <div className="d-flex column-gap-2 align-items-center">
                          <div className="d-flex align-items-center">
                            <Input
                              style={{ width: "70px" }}
                              type="text"
                              value={height}
                              onChange={handleHeightChange}
                              disabled={
                                !inputEnabledHeight || !access.customize_module
                              }
                              invalid={invalidShutterDimensions(height)}
                            />
                            <span className="ms-2 text-body-tertiary">H</span>
                            {!finalisedContexts.includes("carcass") && (
                              <i
                                className="fa-solid fa-pencil-alt"
                                style={{
                                  cursor: "pointer",
                                  marginLeft: "5px",
                                  color: "grey",
                                  visibility: !inputEnabledHeight
                                    ? "visible"
                                    : "hidden",
                                }}
                                onClick={toggleInputHeight}
                              ></i>
                            )}
                          </div>
                          <div className="d-flex align-items-center">
                            <Input
                              style={{ width: "70px" }}
                              type="text"
                              value={width}
                              onChange={handleWidthChange}
                              invalid={invalidShutterDimensions(width)}
                              disabled={
                                !inputEnabledWidth || !access.customize_module
                              }
                            />
                            <span className="ms-2 text-body-tertiary">W</span>
                            {!finalisedContexts.includes("carcass") && (
                              <i
                                className="fa-solid fa-pencil-alt"
                                style={{
                                  cursor: "pointer",
                                  marginLeft: "5px",
                                  color: "grey",
                                  visibility: !inputEnabledWidth
                                    ? "visible"
                                    : "hidden",
                                }}
                                onClick={toggleInputWidth}
                              ></i>
                            )}
                          </div>
                        </div>
                      </div>
                      <hr></hr>

                      {(inputEnabledHeight || inputEnabledWidth) && (
                        <div className="p-3 mr-3 pt-0">
                          <div className="d-flex column-gap-3">
                            <ProjectButton
                              onClick={handleUpdateSpace}
                              className="rounded-2"
                            >
                              Update Space
                            </ProjectButton>
                            <Button
                              onClick={handleCancelForUpdateSpace}
                              className="rounded-1"
                              outline
                            >
                              Cancel
                            </Button>
                          </div>
                        </div>
                      )}

                      {access.customize_module && (
                        <div className="px-2 mt-3 border-top">
                          <Products
                            modulesCategory={modulesCategory}
                            handleCopyTemplate={handleCopyTemplate}
                            spaceDimensions={
                              selectionManager.selectedSpace().dimensions
                            }
                            isSpaceShuttered={
                              selectionManager.selectedSpace().is_shuttered
                            }
                            selectedSpacePath={
                              selectionManager.selectedSpace().path
                            }
                          />
                        </div>
                      )}

                      <ConfirmationModal
                        isOpen={clearSpaceConfirmationOpen}
                        toggle={toggleClearSpaceConfirmation}
                        onConfirm={handleClearSpace}
                        message="Are you sure you want to clear partitions?"
                        headingText="Clear Partitions Confirmation"
                      />
                    </>
                  ) : selectionManager.selectedPartition() ? (
                    <>
                      <div>
                        <div className="info-header">
                          <div className="d-flex align-items-center">
                            <Icon
                              onClick={() => selectionManager.clear()}
                              className="fa-solid fa-arrow-left fs-6 pointer"
                            />
                            <h4 className="fw-bold fs-14px m-0 ms-3">
                              Partition
                            </h4>
                          </div>
                          <SpaceInfoButton
                            className="rounded-2"
                            color="#dc3545"
                            outline
                            size="sm"
                            onClick={toggleRemovePartitionConfirmation}
                            disabled={
                              finalisedContexts.includes("carcass") ||
                              finalisedContexts.includes("shutter") ||
                              selectionManager.selectedPartition().immutable ||
                              !access.customize_module
                            }
                          >
                            <i className="fa-regular fa-trash-can me-2"></i>
                            Remove Partition
                          </SpaceInfoButton>
                        </div>
                        <div className="p-4 border-bottom">
                          <Select
                            options={filteredOptions
                              .filter(
                                (option) =>
                                  option.key !== "fixed_shelf_full_depth"
                              )
                              .map((option) => ({
                                value: option.key,
                                label: option.value,
                              }))}
                            value={
                              filteredOptions.find(
                                (option) => option.key === partitionType
                              )
                                ? {
                                    value: partitionType,
                                    label: filteredOptions.find(
                                      (option) => option.key === partitionType
                                    ).value,
                                  }
                                : null
                            }
                            onChange={(selectedOption) => {
                              const updatedPartition = selectedOption
                                ? selectedOption.value
                                : "";
                              setPartitionType(updatedPartition);
                              handleUpdatePartition(updatedPartition);
                            }}
                            isDisabled={
                              selectionManager.selectedPartition().immutable ||
                              !access.customize_module ||
                              partitionType === "fixed_shelf_full_depth"
                            }
                            placeholder="Select a type"
                          />
                        </div>
                      </div>
                      <ConfirmationModal
                        isOpen={removePartitionConfirmationOpen}
                        toggle={toggleRemovePartitionConfirmation}
                        onConfirm={handleDeletePartition}
                        message="Are you sure you want to remove this partition?"
                        headingText="Remove Partition Confirmation"
                      />
                    </>
                  ) : selectionManager.selectedShutter() &&
                    selectionManager.activeModule().groupedProperties ? (
                    <>
                      <div className="info-header">
                        <div className="d-flex align-items-center">
                          <p className="fw-bold fs-14px m-0">Shutter</p>
                          {selectionManager.selectedShutter().is_removed && (
                            <p className="ms-2 text-secondary m-0">removed</p>
                          )}
                        </div>
                        <i
                          onClick={() => {
                            selectionManager.clear();
                          }}
                          className="fa-solid fa-close pointer fs-5"
                        />
                      </div>
                      {selectionManager.selectedShutter().is_removed ? (
                        <div className="d-flex justify-content-center p-4 border-bottom">
                          <SpaceInfoButton
                            className="rounded-2"
                            color="#2C92E6"
                            disabled={!access.customize_shutter}
                            outline
                            size="sm"
                            onClick={() => toggleAddShutterConfirmation()}
                          >
                            <i className="fa-solid fa-arrow-rotate-left me-2"></i>
                            Revert Shutter
                          </SpaceInfoButton>
                        </div>
                      ) : (
                        <>
                          <div className="border-bottom p-3">
                            {!selectionManager.selectedShutter().is_removed && (
                              <i
                                className="fa-regular fa-trash-can me-2 fs-6 pointer"
                                disabled={!access.customize_shutter}
                                onClick={toggleRemoveShutterConfirmation}
                              ></i>
                            )}
                          </div>
                          <div className="ps-3 pt-3 pb-1 border-bottom">
                            <p className="text-uppercase property-name m-0 fw-bold">
                              Size
                            </p>
                            <div className="d-flex column-gap-4 mt-1">
                              <div className="d-flex flex-column row-gap-2">
                                <div className="d-flex align-items-center">
                                  <span>{shutterHeight}</span>
                                  <span className="ms-2 text-body-tertiary">
                                    H
                                  </span>
                                </div>
                                <div className="d-flex align-items-center">
                                  {selectionManager.selectedShutter().overrides
                                    .shutter?.["length_1"] && (
                                    <>
                                      <div>
                                        <i
                                          className="fa-solid fa-circle-info me-2 text-secondary fs-6"
                                          id="fixed"
                                        />
                                      </div>
                                      <UncontrolledTooltip
                                        target="fixed"
                                        placement="bottom"
                                      >
                                        Size Customized
                                      </UncontrolledTooltip>
                                    </>
                                  )}
                                  {selectionManager.selectedShutter().overrides
                                    .shutter?.["length_1"] && (
                                    <i
                                      onClick={() => {
                                        setClearDimension("height");
                                        toggleOverrideConfirmation(
                                          !removeOverrideConfirmationOpen
                                        );
                                      }}
                                      className="fa-solid fa-arrow-rotate-left text-primary"
                                    ></i>
                                  )}
                                </div>
                              </div>
                              <div className="d-flex flex-column row-gap-2">
                                <div className="d-flex align-items-center">
                                  <span>{shutterWidth}</span>
                                  <span className="ms-2 text-body-tertiary">
                                    W
                                  </span>
                                </div>
                                <div className="d-flex align-items-center">
                                  {selectionManager.selectedShutter().overrides
                                    .shutter?.["length_2"] && (
                                    <>
                                      <div>
                                        <i
                                          className="fa-solid fa-circle-info me-2 text-secondary fs-6"
                                          id="fixed"
                                        />
                                      </div>
                                      <UncontrolledTooltip
                                        target="fixed"
                                        placement="bottom"
                                      >
                                        Size Customized
                                      </UncontrolledTooltip>
                                    </>
                                  )}
                                  {selectionManager.selectedShutter().overrides
                                    .shutter?.["length_2"] && (
                                    <i
                                      onClick={() => {
                                        setClearDimension("width");
                                        toggleOverrideConfirmation(
                                          !removeOverrideConfirmationOpen
                                        );
                                      }}
                                      className="fa-solid fa-arrow-rotate-left text-primary"
                                    ></i>
                                  )}
                                </div>
                              </div>
                            </div>
                          </div>
                          {selectionManager.selectedShutter()
                            .can_dimension_change && (
                            <div className="px-3 pt-3 pb-0 border-bottom">
                              <p className="text-uppercase property-name mt-0 fw-bold">
                                Size Extensions
                              </p>
                              <div className="d-flex flex-column align-items-center mt-1">
                                <div className="mb-2 text-center">
                                  <p
                                    className="mb-1"
                                    style={{ color: "#999999" }}
                                  >
                                    Top
                                  </p>
                                  <input
                                    type="number"
                                    value={shrinkTop}
                                    onChange={(e) =>
                                      setShrinkTop(
                                        e.target.value === "" ? null : parseInt(e.target.value)
                                      )
                                    }
                                    onFocus={() => setActiveInput("top")}
                                    onBlur={() => {
                                      updateShutterConfig(
                                        shrinkLeft,
                                        shrinkRight,
                                        shrinkTop,
                                        shrinkBottom
                                      );
                                      setActiveInput("");
                                    }}
                                    disabled={
                                      selectionManager.selectedShutter()
                                        .overrides.shutter?.["length_1"] ||
                                      selectionManager.selectedShutter()
                                        .overrides.shutter?.["length_2"] ||
                                      !access.customize_shutter ||
                                      disabledDirections.includes("top")
                                    }
                                    className="form-control text-center"
                                    style={{
                                      width: "70px",
                                      border: "1px solid #cccccc",
                                      color:
                                        shrinkTop === 0 ? "#999999" : "#2C51E6",
                                    }}
                                  />
                                </div>

                                <div className="d-flex justify-content-center align-items-center w-100">
                                  <div className="me-3 text-center mb-4">
                                    <p
                                      className="mb-1"
                                      style={{ color: "#999999" }}
                                    >
                                      Left
                                    </p>
                                    <input
                                      type="number"
                                      value={shrinkLeft}
                                      onChange={(e) =>
                                        setShrinkLeft(
                                          e.target.value === "" ? null : parseInt(e.target.value) )
                                      }
                                      onFocus={() => setActiveInput("left")}
                                      onBlur={() => {
                                        updateShutterConfig(
                                          shrinkLeft,
                                          shrinkRight,
                                          shrinkTop,
                                          shrinkBottom
                                        );
                                        setActiveInput("");
                                      }}
                                      disabled={
                                        selectionManager.selectedShutter()
                                          .overrides.shutter?.["length_1"] ||
                                        selectionManager.selectedShutter()
                                          .overrides.shutter?.["length_2"] ||
                                        !access.customize_shutter ||
                                        disabledDirections.includes("left")
                                      }
                                      className="form-control text-center"
                                      style={{
                                        width: "70px",
                                        border: "1px solid #cccccc",
                                        color:
                                          shrinkLeft === 0
                                            ? "#999999"
                                            : "#2C51E6",
                                      }}
                                    />
                                  </div>

                                  <div
                                    className="d-flex justify-content-center align-items-center"
                                    style={{
                                      width: "100px",
                                      height: "100px",
                                      borderTop: `3px solid ${getBorderColor(
                                        shrinkTop
                                      )}`,
                                      borderLeft: `3px solid ${getBorderColor(
                                        shrinkLeft
                                      )}`,
                                      borderRight: `3px solid ${getBorderColor(
                                        shrinkRight
                                      )}`,
                                      borderBottom: `3px solid ${getBorderColor(
                                        shrinkBottom
                                      )}`,
                                    }}
                                  >
                                    Panel
                                  </div>

                                  <div className="ms-3 text-center mb-4">
                                    <p
                                      className="mb-1"
                                      style={{ color: "#999999" }}
                                    >
                                      Right
                                    </p>
                                    <input
                                      type="number"
                                      value={shrinkRight}
                                      onChange={(e) =>
                                        setShrinkRight(
                                          e.target.value === "" ? null : parseInt(e.target.value)
                                        )
                                      }
                                      onFocus={() => setActiveInput("right")}
                                      onBlur={() => {
                                        updateShutterConfig(
                                          shrinkLeft,
                                          shrinkRight,
                                          shrinkTop,
                                          shrinkBottom
                                        );
                                        setActiveInput("");
                                      }}
                                      disabled={
                                        selectionManager.selectedShutter()
                                          .overrides.shutter?.["length_1"] ||
                                        selectionManager.selectedShutter()
                                          .overrides.shutter?.["length_2"] ||
                                        !access.customize_shutter ||
                                        disabledDirections.includes("right")
                                      }
                                      className="form-control text-center"
                                      style={{
                                        width: "70px",
                                        border: "1px solid #cccccc",
                                        color:
                                          shrinkRight === 0
                                            ? "#999999"
                                            : "#2C51E6",
                                      }}
                                    />
                                  </div>
                                </div>

                                <div className="mt-2 text-center">
                                  <input
                                    type="number"
                                    value={shrinkBottom}
                                    onChange={(e) =>
                                      setShrinkBottom(
                                        e.target.value === "" ? null : parseInt(e.target.value)
                                      )
                                    }
                                    onFocus={() => setActiveInput("bottom")}
                                    onBlur={() => {
                                      updateShutterConfig(
                                        shrinkLeft,
                                        shrinkRight,
                                        shrinkTop,
                                        shrinkBottom
                                      );
                                      setActiveInput("");
                                    }}
                                    disabled={
                                      selectionManager.selectedShutter()
                                        .overrides.shutter?.["length_1"] ||
                                      selectionManager.selectedShutter()
                                        .overrides.shutter?.["length_2"] ||
                                      !access.customize_shutter ||
                                      disabledDirections.includes("bottom")
                                    }
                                    className="form-control text-center mx-auto"
                                    style={{
                                      width: "70px",
                                      border: "1px solid #cccccc",
                                      color:
                                        shrinkBottom === 0
                                          ? "#999999"
                                          : "#2C51E6",
                                    }}
                                  />
                                  <p
                                    className="pt-1"
                                    style={{ color: "#999999" }}
                                  >
                                    Bottom
                                  </p>
                                </div>
                              </div>
                            </div>
                          )}
                          {selectionManager
                            .selectedShutter()
                            .component.panels.map((panel, panelIndex) => (
                              <div className="p-3 border-bottom">
                                {(() => {
                                  const options = selectionManager
                                    .activeModule()
                                    .groupedProperties[null].find(
                                      (e) => e.identifier === "color"
                                    ).options;
                                  const selectedOption = options.find(
                                    (e) =>
                                      e.identifier ===
                                      shutterColor[panel.identifier]
                                  );
                                  return (
                                    <>
                                      <p className="text-uppercase property-name mt-0 mb-1 fw-bold">
                                        {panel.name} color
                                      </p>
                                      <div className="d-flex align-items-center">
                                        {options.length > 0 && (
                                          <Select
                                            isDisabled={
                                              !access.customize_shutter
                                            }
                                            className="flex-grow-1"
                                            options={options.map(
                                              (option, index) => {
                                                option.value =
                                                  option.identifier;
                                                option.label = option.image ? (
                                                  <div key={index}>
                                                    {option.image && (
                                                      <OptionImage
                                                        src={option.image}
                                                        alt={option.name}
                                                        className="me-2 border border-dark rounded-circle"
                                                      />
                                                    )}
                                                    {option.name}
                                                  </div>
                                                ) : (
                                                  option.name
                                                );

                                                return {
                                                  ...option,
                                                };
                                              }
                                            )}
                                            value={
                                              selectedOption
                                                ? selectedOption
                                                : null
                                            }
                                            onChange={(e) => {
                                              setCurrentPanelIdentifier(
                                                panel.identifier
                                              );
                                              setShutterColor({
                                                ...shutterColor,
                                                [panel.identifier]: e.value,
                                              });
                                            }}
                                          />
                                        )}
                                        {!options.length && (
                                          <div className="py-2 d-flex">
                                            <div className="text-secondary">
                                              No color added to the project.
                                            </div>
                                            <a
                                              onClick={() =>
                                                setCurrentTab("materials")
                                              }
                                              href="#"
                                              className="ms-2"
                                            >
                                              Manage Colors
                                            </a>
                                          </div>
                                        )}
                                        {!finalisedContexts.includes(
                                          "shutter"
                                        ) &&
                                          selectionManager.selectedShutter()
                                            .overrides[panel.identifier]?.[
                                            "external_color"
                                          ] && (
                                            <i
                                              className="ms-3 fa-solid fa-arrow-rotate-left text-primary"
                                              onClick={() => {
                                                // FIXME
                                                setClearDimension("color");
                                                setIsRemoveShutterColorOverrideOpen(
                                                  true
                                                );
                                                setCurrentPanelIdentifier(
                                                  panel.identifier
                                                );
                                              }}
                                            ></i>
                                          )}
                                      </div>
                                      {() => {
                                        const selectedOption = options.find(
                                          (option) => option.selected
                                        );

                                        return (
                                          !selectionManager.selectedShutter()
                                            .overrides[panel.identifier]?.[
                                            "external_color"
                                          ] &&
                                          selectedOption && (
                                            <div className="invalid-feedback d-block text-secondary">
                                              {selectedOption.name}
                                              &nbsp;
                                              <i style={{ color: "black" }}>
                                                (using from module settings)
                                              </i>
                                            </div>
                                          )
                                        );
                                      }}
                                    </>
                                  );
                                })()}
                              </div>
                            ))}

                          <div className="p-3 border-bottom">
                            {(() => {
                              const options = [
                                { label: "None", value: "none" },
                                { label: "Simple", value: "simple" },
                                { label: "Complex", value: "complex" },
                              ];
                              const selectedOption = options.find(
                                (e) => e.value === shutterCNCType
                              );

                              return (
                                <>
                                  <p className="text-uppercase property-name mt-0 mb-1 fw-bold">
                                    CNC Type
                                  </p>
                                  <div className="d-flex align-items-center">
                                    <Select
                                      isDisabled={!access.customize_shutter}
                                      className="flex-grow-1"
                                      options={options}
                                      value={selectedOption}
                                      onChange={(e) => {
                                        setCurrentPanelIdentifier("panel");
                                        setShutterCNCType(e.value);
                                      }}
                                    />
                                  </div>
                                </>
                              );
                            })()}
                          </div>
                          {/*PATTERN TYPE*/}
                          <div className="p-3 border-bottom">
                            {(() => {
                              const options = [
                                { label: "None", value: "none" },
                                { label: "Simple", value: "simple" },
                                { label: "Complex", value: "complex" },
                              ];
                              const selectedOption = options.find(
                                (e) => e.value === shutterPatternType
                              );

                              return (
                                <>
                                  <p className="text-uppercase property-name mt-0 mb-1 fw-bold">
                                    Pattern Type
                                  </p>
                                  <div className="d-flex align-items-center">
                                    <Select
                                      isDisabled={!access.customize_shutter}
                                      className="flex-grow-1"
                                      options={options}
                                      value={selectedOption}
                                      onChange={(e) => {
                                        setCurrentPanelIdentifier("panel");
                                        setShutterPatternType(e.value);
                                      }}
                                    />
                                  </div>
                                </>
                              );
                            })()}
                          </div>
                        </>
                      )}
                    </>
                  ) : selectionManager.selectedModule() &&
                    selectionManager.selectedModule().isPrepared ? (
                    isCutlist ? (
                      <>
                        <div className="d-flex justify-content-between align-items-center border-bottom border-secondary-subtle p-3">
                          <h4 className="fw-bold fs-14px m-0">Cutlist</h4>
                          <div className="d-flex align-items-center column-gap-3">
                            {isAdmin && (
                              <div>
                                <i
                                  id="price_detailed_view"
                                  onClick={() => {
                                    setPriceSummary(!priceSummary);
                                    setPanelSummary(false);
                                  }}
                                  className={`fa-solid fa-indian-rupee-sign highlight-on-hover pointer fs-6 ${
                                    priceSummary
                                      ? "text-black"
                                      : "text-light-emphasis"
                                  }`}
                                ></i>
                                <UncontrolledTooltip
                                  target="price_detailed_view"
                                  placement="bottom"
                                >
                                  Price Summary
                                </UncontrolledTooltip>
                              </div>
                            )}
                            <div>
                              <i
                                id="panel_detailed_view"
                                onClick={() => {
                                  setPanelSummary(!panelSummary);
                                  setPriceSummary(false);
                                }}
                                className={`fa-solid fa-border-all highlight-on-hover pointer fs-6 ${
                                  panelSummary
                                    ? "text-black"
                                    : "text-light-emphasis"
                                }`}
                              ></i>
                              <UncontrolledTooltip
                                target="panel_detailed_view"
                                placement="bottom"
                              >
                                Detailed Summary
                              </UncontrolledTooltip>
                            </div>
                            <i
                              onClick={() => {
                                setIsCutlist(false);
                                setPriceSummary(false);
                                setPanelSummary(false);
                              }}
                              className="fa-solid fa-close pointer fs-5 text-secondary"
                            />
                          </div>
                        </div>
                        {cutlists.map((cutlist, index) => (
                          <div key={index}>
                            {cutlist.panels.length > 1 && (
                              <div
                                className="d-flex justify-content-between align-items-center p-2 border-bottom border-secondary-subtle"
                                style={{ background: "#E5E5E5" }}
                              >
                                <div className="d-flex align-items-center column-gap-2">
                                  <div
                                    className="text-white fw-bold bg-secondary rounded-circle"
                                    style={{ padding: "3px 5px" }}
                                  >
                                    {cutlist.label}
                                  </div>
                                  <div className="text-capitalize">
                                    {cutlist.type}
                                  </div>
                                </div>
                                {priceSummary && (
                                  <div className="fw-bold">
                                    {cutlist.rate
                                      ? `₹${cutlist.rate}`
                                      : "Price Outdated"}
                                  </div>
                                )}
                              </div>
                            )}
                            {cutlist.panels.map((panel, panelIndex) => (
                              <div
                                className={`d-flex align-items-start column-gap-2 p-2 ps-4 border-bottom border-secondary-subtle ${
                                  !panelSummary && "align-items-center"
                                }`}
                                key={panelIndex}
                                style={{
                                  ...(cutlist.panels.length === 1 && {
                                    background: "#E5E5E5",
                                  }),
                                }}
                              >
                                {cutlist.panels.length > 1 ? (
                                  <div
                                    className="text-secondary fw-bold border border-secondary rounded-circle"
                                    style={{ padding: "0px 6px" }}
                                  >
                                    {panel.label}
                                  </div>
                                ) : (
                                  <div
                                    className="text-white fw-bold bg-secondary rounded-circle"
                                    style={{ padding: "3px 5px" }}
                                  >
                                    {cutlist.label}
                                  </div>
                                )}
                                <div className="w-100">
                                  <div className="d-flex justify-content-between">
                                    <div className="d-flex column-gap-2">
                                      <p className="m-0">{panel.name}</p>
                                      {priceSummary ? (
                                        cutlist.rate && (
                                          <p className="m-0 text-secondary">
                                            ₹{panel.price_and_wastage.rate}
                                            {" (" +
                                              panel.price_and_wastage.wastage +
                                              "%)"}
                                          </p>
                                        )
                                      ) : (
                                        <p className="m-0 text-secondary">
                                          {panel.thickness}mm
                                        </p>
                                      )}
                                    </div>
                                    {priceSummary ? (
                                      cutlist.panels.length === 1 ? (
                                        <p className="m-0 fw-bold">
                                          {cutlist.rate
                                            ? `₹${cutlist.rate}`
                                            : "Price Outdated"}
                                        </p>
                                      ) : (
                                        cutlist.rate && (
                                          <p className="m-0 fw-bold">
                                            ₹
                                            {
                                              panel.price_and_wastage
                                                .module_rate
                                            }
                                          </p>
                                        )
                                      )
                                    ) : (
                                      <p className="m-0 text-secondary">
                                        {panel.length_1} x {panel.length_2}
                                      </p>
                                    )}
                                  </div>
                                  {panelSummary && (
                                    <div className="d-flex justify-content-between align-items-start column-gap-4 mt-1">
                                      <div className="text-secondary">
                                        {panel.color_1}{" "}
                                        {panel.color_1 !== panel.color_2 &&
                                          `/ ${panel.color_2}`}
                                        {panel.edges && ` | ${panel.edges}`}
                                      </div>
                                      {panel.grooves && (
                                        <div className="px-1 text-secondary border border-secondary-subtle">
                                          G
                                        </div>
                                      )}
                                    </div>
                                  )}
                                </div>
                              </div>
                            ))}
                          </div>
                        ))}
                      </>
                    ) : showReplaceTemplate ? (
                      <>
                        <div className="d-flex column-gap-2 align-items-center border-bottom p-3">
                          <i
                            onClick={() => setShowReplaceTemplate(false)}
                            className="fa-solid fa-arrow-left fs-5 pointer"
                          />
                          <p className="fw-bold fs-14px m-0">Replace Module</p>
                        </div>
                        <TabContent activeTab="1" className="p-3 pt-0">
                          <TabPane tabId="1">
                            <Products
                              orderItemId={selectionManager.activeModule().id}
                              changeTemplate={changeTemplate}
                              catalogType={
                                selectionManager.activeModule().catalog_type
                              }
                              catalogSubType={
                                selectionManager.activeModule().catalog_sub_type
                              }
                            />
                          </TabPane>
                        </TabContent>
                      </>
                    ) : (
                      <>
                        <div className="info-header show-overflow">
                          {
                            <OrderItemNameComponent
                              orderItemName={orderItemName}
                              setOrderItemName={setOrderItemName}
                              orderItemUserLabel={orderItemUserLabel}
                              setOrderItemUserLabel={setOrderItemUserLabel}
                              showOIEditBox={showOIEditBox}
                              setShowOIEditBox={setShowOIEditBox}
                              handleUpdateOrderItemData={
                                handleUpdateOrderItemData
                              }
                              activeOIInput={activeOIInput}
                              setActiveOIInput={setActiveOIInput}
                              access={access}
                            ></OrderItemNameComponent>
                          }

                          <div className="d-flex justify-content-between align-items-center">
                            {(isAdmin || organizationData.get_item_cutlist) && (
                              <>
                                <Icon
                                  className="fa-solid fa-list-ul pointer px-3"
                                  style={{ color: "#86858a", fontSize: "16px" }}
                                  onClick={() => handleCutlistClick()}
                                  id="cutlist"
                                />
                                <UncontrolledTooltip
                                  target="cutlist"
                                  placement="bottom"
                                >
                                  Show Cutlist{" "}
                                </UncontrolledTooltip>
                              </>
                            )}
                            <i
                              onClick={() => selectionManager.clear()}
                              className="fa-solid fa-close pointer fs-5"
                            />
                          </div>
                        </div>
                        {!isListProject && access.clone_module && (
                          <div className="d-flex align-items-center column-gap-3 px-3 py-2 border-bottom">
                            <div className="d-flex">
                              <i
                                className="fa-regular fa-clone fs-6 highlight-on-hover pointer"
                                id="clone_module"
                                onClick={() => cloneSelectedItems()}
                              ></i>
                              <UncontrolledTooltip
                                target="clone_module"
                                placement="bottom"
                              >
                                Duplicate Module
                              </UncontrolledTooltip>
                            </div>
                            <i
                              className="fa-regular fa-trash-can fs-6 highlight-on-hover pointer"
                              onClick={() =>
                                !isLoading &&
                                setShowItemsDeleteConfirmation(true)
                              }
                            />
                            <div
                              onClick={() => groupSelectedItems()}
                              className={`mt-1 pointer highlight-on-hover ${
                                selectionManager.allowGrouping()
                                  ? ""
                                  : "disabled"
                              }`}
                              id="group_action"
                            >
                              <i className="fa-regular fa-object-group fs-6" />
                            </div>
                            <UncontrolledTooltip
                              target="group_action"
                              placement="bottom"
                            >
                              Group selected item
                            </UncontrolledTooltip>
                          </div>
                        )}
                        {selectionManager.selectedModule() && isAdmin && (
                          <div className="d-flex px-1 border-bottom">
                            <p
                              className={`m-0 p-2 tab ${
                                activePropertyTab === "user" ? "active" : ""
                              } me-2`}
                              onClick={() => setActivePropertyTab("user")}
                            >
                              User
                            </p>
                            <p
                              className={`m-0 p-2 tab ${
                                activePropertyTab === "admin" ? "active" : ""
                              }`}
                              onClick={() => setActivePropertyTab("admin")}
                            >
                              Admin
                            </p>
                          </div>
                        )}

                        <div className="position-relative py-2 overflow-scroll fh">
                          <MultiUpdateModal
                            modules={getSelectedItems()}
                            updateProperties={updateProperties}
                            projectId={projectId}
                            isLoading={isRightPaneLoading}
                            setIsLoading={setIsRightPaneLoading}
                            access={access}
                            finalisedContexts={finalisedContexts}
                            selectionManager={selectionManager}
                            projectSettings={projectSettings}
                            isDesigner={isDesigner}
                            isViewer={isViewer}
                            activePropertyTab={activePropertyTab}
                            is_order_finalised={isOrderFinalised}
                            isOrderDraft={isOrderDraft}
                            currentRoom={currentRoom}
                            loadRoom={loadRoom}
                            invalidDimension={invalidDimension}
                            lightsList={lightsList}
                            setShowLightForm={setShowLightForm}
                            setLightInfo={setLightInfo}
                            openLightGroove={openLightGroove}
                            toggleLightGroove={toggleLightGroove}
                            replaceModule={replaceModule}
                            refreshProjectSummary={refreshProjectSummary}
                            setChangedProperty={setChangedProperty}
                            setErrorMessage={setErrorMessage}
                            changedProperty={changedProperty}
                            errorMessage={errorMessage}
                            isListProject={isListProject}
                          />
                        </div>
                      </>
                    )
                  ) : selectionManager.selectedWall() ? (
                    <>
                      <div className="info-header">
                        {
                          <InlineEdit
                            defaultValue={selectionManager.selectedWall().name}
                            value={wallName}
                            className="fs-18px fw-bold mb-0 hover-underline"
                            onChange={(e) => {
                              access.update_wall && setWallName(e);
                            }}
                            onSave={handleWallNameUpdate}
                          ></InlineEdit>
                        }

                        <div className="d-flex justify-content-between align-items-center">
                          <i
                            className="fa-regular fa-clone fs-6 pointer"
                            id="clone_wall"
                            onClick={() =>
                              access.clone_module && cloneSelectedItems()
                            }
                          ></i>
                          <UncontrolledTooltip
                            target="clone_wall"
                            placement="bottom"
                          >
                            Duplicate Module
                          </UncontrolledTooltip>
                          <span
                            className="fa-solid fa-trash mx-3 fs-6 pointer"
                            onClick={() =>
                              access.delete_wall &&
                              setShowDeleteWallConfirmation(true)
                            }
                          ></span>
                          <i
                            onClick={() => selectionManager.clear()}
                            className="fa-solid fa-close pointer fs-4"
                          />
                        </div>
                      </div>
                      <div className="p-3 pb-0">
                        <div className="d-flex column-gap-2 align-items-center">
                          <div className="d-flex align-items-center">
                            <Input
                              style={{ width: "70px" }}
                              type="text"
                              value={height}
                              onChange={handleHeightChange}
                              invalid={invalidShutterDimensions(height)}
                            />
                            <span className="ms-2 text-body-tertiary">H</span>
                          </div>
                          <div className="d-flex align-items-center">
                            <Input
                              style={{ width: "70px" }}
                              type="text"
                              value={width}
                              onChange={handleWidthChange}
                              invalid={invalidShutterDimensions(width)}
                            />
                            <span className="ms-2 text-body-tertiary">W</span>
                          </div>
                        </div>
                      </div>
                      <hr></hr>
                      {
                        <div className="p-3 mr-3 pt-0">
                          <div className="d-flex column-gap-3">
                            <ProjectButton
                              onClick={access.update_wall && handleUpdateWall}
                              className="rounded-2"
                            >
                              Update
                            </ProjectButton>
                            <Button
                              onClick={handleCancelForUpdateWall}
                              className="rounded-1"
                              outline
                            >
                              Cancel
                            </Button>
                          </div>
                        </div>
                      }
                    </>
                  ) : selectionManager.selections().length > 1 &&
                    selectionManager.areSelectionsHomogenous("shutter") ? (
                    <>
                      <div
                        className="d-flex justify-content-between align-items-center p-3 border-bottom text-capitalize"
                        style={{ background: "#D9D9D9" }}
                      >
                        <h6 className="m-0 fw-bold">
                          {selectionManager.selections().length +
                            " " +
                            (selectionManager.areSelectionsHomogenous()
                              ? selectionManager.selections()[0].type + "s"
                              : "")}{" "}
                          selected
                        </h6>
                        <i
                          className="fa-solid fa-close fs-5 text-secondary pointer"
                          onClick={() => selectionManager.clear()}
                        />
                      </div>
                      <div className="p-3 border-bottom d-flex justify-content-center">
                        <Button
                          className="bg-primary border-0 rounded-1"
                          onClick={
                            access.customize_shutter &&
                            toggleMergeShutterConfirmation
                          }
                        >
                          Merge Shutters
                        </Button>
                      </div>
                      {access.customize_shutter &&
                        selectionManager
                          .selections()
                          .every(
                            (selection) =>
                              selection.component.panels.length === 1
                          ) && (
                          <div className="p-3 border-bottom">
                            {(() => {
                              const options = selectionManager
                                .findModule(
                                  selectionManager.selections()[0].order_item_id
                                )
                                .groupedProperties[null].find(
                                  (e) => e.identifier === "color"
                                ).options;
                              const isOverriden = selectionManager
                                .selections()
                                .some(
                                  (e) => e.overrides.shutter?.["external_color"]
                                );
                              const selectedOption = options.find(
                                (e) => e.identifier === shutterColor["shutter"]
                              );
                              return (
                                <>
                                  <p className="text-uppercase property-name mt-0 mb-1 fw-bold">
                                    shutter color
                                  </p>
                                  <div className="d-flex align-items-center">
                                    <Select
                                      isDisabled={finalisedContexts.includes(
                                        "shutter"
                                      )}
                                      className="flex-grow-1"
                                      options={options.map((option) => ({
                                        label: option.name,
                                        value: option.identifier,
                                      }))}
                                      value={
                                        selectedOption
                                          ? {
                                              label: selectedOption.name,
                                              value: selectedOption.identifier,
                                            }
                                          : null
                                      }
                                      onChange={(e) => {
                                        // FIX HERE
                                        setShutterColor(e.value);
                                        updateShuttersConfig(e.value);
                                      }}
                                    />
                                    {!finalisedContexts.includes("shutter") &&
                                      isOverriden && (
                                        <i
                                          className="ms-3 fa-solid fa-arrow-rotate-left text-primary"
                                          onClick={() => {
                                            // FIXME
                                            setClearDimension("color");
                                            setIsRemoveShutterColorOverrideOpen(
                                              true
                                            );
                                          }}
                                        ></i>
                                      )}
                                  </div>
                                  {isOverriden ? (
                                    <div className="invalid-feedback d-block text-secondary">
                                      <i style={{ color: "black" }}>
                                        (Some shutter colors are overridden)
                                      </i>
                                    </div>
                                  ) : (
                                    <div className="invalid-feedback d-block text-secondary">
                                      {
                                        options.find(
                                          (option) => option.selected
                                        ).name
                                      }
                                      &nbsp;
                                      <i style={{ color: "black" }}>
                                        (using from module settings)
                                      </i>
                                    </div>
                                  )}
                                </>
                              );
                            })()}
                          </div>
                        )}
                    </>
                  ) : selectionManager.selections().length > 1 ||
                    selectionManager.selectedGroup() ? (
                    <>
                      {selectionManager.selectedGroup() ? (
                        <>
                          <div className="info-header">
                            <p className="fs-14px fw-bold mb-0">
                              {selectionManager.selection().name}
                            </p>
                            <i
                              onClick={() => {
                                selectionManager.clear();
                                setShowModal(false);
                              }}
                              className="fa-solid fa-close pointer fs-5"
                            />
                          </div>
                          {selectionManager.selectedGroup().category !==
                            "Section" &&
                            access.customize_module && (
                              <>
                                <div className="d-flex border-bottom">
                                  <div className="d-flex px-3 py-2">
                                    {access.add_module &&
                                      !showAddModule &&
                                      selectionManager.selectedGroup()
                                        .category === "StackedGroup" && (
                                        <div>
                                          <i
                                            className="fa-solid fa-circle-plus fs-6 highlight-on-hover pointer"
                                            onClick={() =>
                                              setShowAddModule(true)
                                            }
                                            id="addmodule"
                                          ></i>
                                          <UncontrolledTooltip
                                            target={`addmodule`}
                                            placement="bottom"
                                          >
                                            Add module
                                          </UncontrolledTooltip>
                                        </div>
                                      )}
                                    <i
                                      className={`fa-regular fa-clone fs-6 highlight-on-hover pointer ${
                                        selectionManager.selectedGroup()
                                          .category === "StackedGroup" && "ms-3"
                                      }`}
                                      id="clone_group"
                                      onClick={() => cloneSelectedItems()}
                                    ></i>
                                    <UncontrolledTooltip
                                      target="clone_group"
                                      placement="bottom"
                                    >
                                      Duplicate Group
                                    </UncontrolledTooltip>
                                    <i
                                      className="fa-regular fa-trash-can fs-6 highlight-on-hover pointer ms-3"
                                      onClick={() =>
                                        !isLoading &&
                                        setShowItemsDeleteConfirmation(true)
                                      }
                                    />
                                    <div className="ms-3">
                                      <i
                                        className="fa-solid fa-object-ungroup fs-6 highlight-on-hover pointer"
                                        onClick={() => unGroupSelectedItems()}
                                        id="ungroup"
                                      ></i>
                                      <UncontrolledTooltip
                                        target={`ungroup`}
                                        placement="bottom"
                                      >
                                        Ungroup
                                      </UncontrolledTooltip>
                                    </div>
                                  </div>
                                  <div
                                    ref={popover1Ref}
                                    className="px-3 py-2 position-toggle h-100 fw-bold pointer d-flex align-items-center"
                                    onClick={() => setShowModal(!showModal)}
                                    style={{
                                      borderLeft: "1px solid #CCCCCC",
                                      color: showModal ? " #2c92e6 " : "",
                                    }}
                                  >
                                    Position
                                  </div>
                                </div>
                                <RightSideModal
                                  showModal={showModal}
                                  setShowModal={setShowModal}
                                  selectionManager={selectionManager}
                                  getObjectKey={getObjectKey}
                                  items={
                                    selectionManager.selectedGroup().modules
                                  }
                                  historyManager={historyManager}
                                  projectId={projectId}
                                  currentRoom={currentRoom}
                                  loadRoom={loadRoom}
                                  targetRef={popover1Ref}
                                  forceUpdate={forceUpdate}
                                />
                              </>
                            )}

                          {showAddModule && (
                            <>
                              <CloseButtonContainer
                                onClick={() => setShowAddModule(false)}
                                right="-0.3rem"
                              >
                                <CloseButton size="12px" padding="7px" />
                              </CloseButtonContainer>

                              <TabContent activeTab="1" className="mt-2 mx-2">
                                <TabPane tabId="1">
                                  <Products
                                    setIsRightPaneLoading={
                                      setIsRightPaneLoading
                                    }
                                  />
                                </TabPane>
                              </TabContent>
                            </>
                          )}
                        </>
                      ) : null}
                      {!showAddModule && (
                        <>
                          {selectionManager.selections().length > 1 && (
                            <div className="relative">
                              <div
                                className="d-flex justify-content-between align-items-center p-3 border-bottom text-capitalize"
                                style={{ background: "#D9D9D9" }}
                              >
                                <h6 className="m-0 fw-bold">
                                  {selectionManager.selections().length +
                                    " " +
                                    (selectionManager.areSelectionsHomogenous()
                                      ? selectionManager.selections()[0].type +
                                        "s"
                                      : "")}{" "}
                                  selected
                                </h6>
                                <i
                                  className="fa-solid fa-close fs-5 text-secondary pointer"
                                  onClick={() => {
                                    selectionManager.clear();
                                    setShowModal(false);
                                  }}
                                />
                              </div>
                              {selectionManager.areSelectionsCanDelete() &&
                                access.clone_module && (
                                  <>
                                    <div className="d-flex column-gap-1 border-bottom border-secondary-subtle">
                                      {!isListProject && (
                                        <div className="d-flex p-2">
                                          <ActionIcon
                                            id="clone_action"
                                            onClick={() => cloneSelectedItems()}
                                            className={`${
                                              selectionManager.canSelectionsClone()
                                                ? ""
                                                : "disabled"
                                            }`}
                                          >
                                            <i className="fa-regular fa-clone fs-6"></i>
                                          </ActionIcon>
                                          <UncontrolledTooltip
                                            target="clone_action"
                                            placement="bottom"
                                          >
                                            Duplicate items
                                          </UncontrolledTooltip>
                                          <ActionIcon id="delete_action">
                                            <i
                                              className="fa-regular fa-trash-can fs-6"
                                              onClick={() =>
                                                !isLoading &&
                                                setShowItemsDeleteConfirmation(
                                                  true
                                                )
                                              }
                                            />
                                          </ActionIcon>
                                          <UncontrolledTooltip
                                            target="delete_action"
                                            placement="bottom"
                                          >
                                            Delete selected items
                                          </UncontrolledTooltip>
                                          <ActionIcon
                                            onClick={() => groupSelectedItems()}
                                            className={`${
                                              selectionManager.allowGrouping()
                                                ? ""
                                                : "disabled"
                                            }`}
                                            id="group_action"
                                          >
                                            <i className="fa-regular fa-object-group fs-6" />
                                          </ActionIcon>
                                          <UncontrolledTooltip
                                            target="group_action"
                                            placement="bottom"
                                          >
                                            Group selected items
                                          </UncontrolledTooltip>
                                          <ActionIcon
                                            onClick={() =>
                                              unGroupSelectedItems()
                                            }
                                            className={`${
                                              selectionManager.canSelectionsUnGroup()
                                                ? ""
                                                : "disabled"
                                            }`}
                                            id="multi_ungroup_action"
                                          >
                                            <i className="fa-solid fa-object-ungroup fs-6" />
                                          </ActionIcon>
                                          <UncontrolledTooltip
                                            target="multi_ungroup_action"
                                            placement="bottom"
                                          >
                                            Ungroup selected items
                                          </UncontrolledTooltip>
                                        </div>
                                      )}

                                      <div
                                        ref={popover2Ref}
                                        className="p-3 h-100 fw-bold pointer d-flex align-items-center"
                                        onClick={() => setShowModal(!showModal)}
                                        style={{
                                          borderLeft: "1px solid #CCCCCC",
                                          color: showModal ? " #2c92e6 " : "",
                                        }}
                                      >
                                        Position
                                      </div>
                                    </div>
                                    <RightSideModal
                                      showModal={showModal}
                                      setShowModal={setShowModal}
                                      selectionManager={selectionManager}
                                      getObjectKey={getObjectKey}
                                      items={selectionManager.selections()}
                                      historyManager={historyManager}
                                      projectId={projectId}
                                      currentRoom={currentRoom}
                                      loadRoom={loadRoom}
                                      targetRef={popover2Ref}
                                      forceUpdate={forceUpdate}
                                    />
                                  </>
                                )}
                            </div>
                          )}

                          {getSelectedItems().length > 0 && (
                            <>
                              {isAdmin && (
                                <div className="d-flex px-1 border-bottom">
                                  <p
                                    className={`m-0 p-2 tab ${
                                      activePropertyTab === "user"
                                        ? "active"
                                        : ""
                                    } me-2`}
                                    onClick={() => setActivePropertyTab("user")}
                                  >
                                    User
                                  </p>
                                  <p
                                    className={`m-0 p-2 tab ${
                                      activePropertyTab === "admin"
                                        ? "active"
                                        : ""
                                    }`}
                                    onClick={() =>
                                      setActivePropertyTab("admin")
                                    }
                                  >
                                    Admin
                                  </p>
                                </div>
                              )}
                              <div className="justify-content-between align-items-center border-bottom py-2 mb-3 fh overflow-scroll">
                                <MultiUpdateModal
                                  modules={getSelectedItems()}
                                  updateProperties={updateProperties}
                                  projectId={projectId}
                                  isLoading={isRightPaneLoading}
                                  access={access}
                                  finalisedContexts={finalisedContexts}
                                  projectSettings={projectSettings}
                                  isDesigner={isDesigner}
                                  isViewer={isViewer}
                                  activePropertyTab={activePropertyTab}
                                  is_order_finalised={isOrderFinalised}
                                  isOrderDraft={isOrderDraft}
                                  currentRoom={currentRoom}
                                  loadRoom={loadRoom}
                                  replaceModule={replaceModule}
                                  refreshProjectSummary={refreshProjectSummary}
                                  invalidDimension={invalidDimension}
                                  selectionManager={selectionManager}
                                  hasMoreThanTwoItems={true}
                                  setChangedProperty={setChangedProperty}
                                  setErrorMessage={setErrorMessage}
                                  changedProperty={changedProperty}
                                  errorMessage={errorMessage}
                                  isListProject={isListProject}
                                />
                              </div>
                            </>
                          )}
                        </>
                      )}
                    </>
                  ) : (
                    <div className="fh d-flex justify-content-center align-items-center fs-6 text-secondary">
                      Select any object to customise.
                    </div>
                  )}
                </div>
              </>
            )}
          </div>
        </div>
      ) : (
        <div className="d-flex align-items-start position-relative">
          <div className="fh flex-grow-1">
            {currentRoom && (
              <SectionCanvas
                selectionManager={selectionManager}
                historyManager={historyManager}
                currentRoom={currentRoom}
                showShutters={showShutters}
                setShowShutters={setShowShutters}
                notificationMessage={notificationMessage}
                projectId={projectId}
                loadRoom={loadRoom}
                isLoading={isLoading}
                isReset={isReset}
                setIsReset={setIsReset}
                position={position}
                setPosition={setPosition}
                zoom={zoom}
                setZoom={setZoom}
                getObjectKey={getObjectKey}
                hoverItem={hoverItem}
                setHoverItem={setHoverItem}
                isEq={isEq}
                access={access}
                containerRef={containerRef}
                setCurrentTab={setCurrentTab}
                projectSummary={projectSummary}
              />
            )}
          </div>
          {!isCurrentTab("info") && (
            <div
              className={`right-pane fh position-relative overflow-hidden ${
                ["project_import", "order"].includes(currentTab) && "wide"
              }`}
              style={{ zIndex: '5' }}
            >
              {isCurrentTab("project_import") ? (
                <ProjectImport
                  loadProject={loadProject}
                  setCurrentTab={setCurrentTab}
                />
              ) : (
                <>
                  <div className="d-flex justify-content-between align-items-center border-bottom p-3">
                    <p className="fw-bold fs-6 m-0 text-capitalize">
                      {currentTab}
                    </p>
                    <i
                      onClick={() => setCurrentTab("info")}
                      className="fa-solid fa-xmark fs-4 pointer text-secondary"
                    />
                  </div>
                  <div className="p-0">
                    {isCurrentTab("colors") ? (
                      <Colors
                        currentRoom={currentRoom}
                        loadRoom={loadRoom}
                        access={access}
                      />
                    ) : isCurrentTab("settings") ? (
                      <>
                        {isAdmin && (
                          <div className="d-flex px-1 border-bottom">
                            <p
                              className={`m-0 p-2 tab ${
                                activePropertyTab === "user" ? "active" : ""
                              } me-2`}
                              onClick={() => setActivePropertyTab("user")}
                            >
                              User
                            </p>
                            <p
                              className={`m-0 p-2 tab ${
                                activePropertyTab === "admin" ? "active" : ""
                              }`}
                              onClick={() => setActivePropertyTab("admin")}
                            >
                              Admin
                            </p>
                          </div>
                        )}
                        <ProjectSettingsModal
                          currentRoom={currentRoom}
                          loadRoom={loadRoom}
                          access={access}
                          isDesigner={isDesigner}
                          isViewer={isViewer}
                          activePropertyTab={activePropertyTab}
                          is_order_finalised={isOrderFinalised}
                          isOrderDraft={isOrderDraft}
                          finalisedContexts={finalisedContexts}
                          isListProject={isListProject}
                        />
                      </>
                    ) : (
                      isCurrentTab("order") && (
                        <NewOrder
                          isAdmin={isAdmin}
                          isDesigner={isDesigner}
                          currentRoom={currentRoom}
                          loadRoom={loadRoom}
                        />
                      )
                    )}
                  </div>
                </>
              )}
            </div>
          )}
        </div>
      )}
      <ConfirmationModal
        isOpen={removeOverrideConfirmationOpen}
        toggle={toggleOverrideConfirmation}
        onConfirm={() => updateShutterConfig()}
        message={`${`Are you sure you want to reset to default ${clearDimension}`}`}
        headingText={`${"Clear Fixed Dimension"}`}
      />
      <ConfirmationModal
        isOpen={isRemoveShutterColorOverrideOpen}
        toggle={() => setIsRemoveShutterColorOverrideOpen(false)}
        onConfirm={() => {
          selectionManager.selections.length === 1
            ? updateShutterConfig(null, currentPanelIdentifier)
            : updateShuttersConfig(null, currentPanelIdentifier);
          setCurrentPanelIdentifier(null);
        }}
        message="Are you sure you want to reset the shutter color?"
        headingText="Reset shutter color"
      />
      <ConfirmationModal
        isOpen={removeShutterConfirmationOpen}
        toggle={toggleRemoveShutterConfirmation}
        onConfirm={() => removeSelectedShutter()}
        message="Are you sure you want to remove the shutter"
        headingText="Remove Shutter"
      />
      <ConfirmationModal
        isOpen={addShutterConfirmationOpen}
        toggle={toggleAddShutterConfirmation}
        onConfirm={() => addRemovedShutter()}
        message="Are you sure you want to add the shutter"
        headingText="Add Shutter"
      />
      <ConfirmationModal
        isOpen={regenerateShuttersConfirmation}
        toggle={() => setRegenerateShuttersConfirmation(false)}
        onConfirm={() => {
          copyTemplateMethod();
        }}
        message="Some shutters will be regenerated after this change. Do you want to continue?"
        headingText="Confirm Regeneration"
      />
      <ConfirmationModal
        isOpen={showDeleteWallConfirmation}
        toggle={toggleShowDeleteWallConfirmation}
        onConfirm={() => handleWallDelete()}
        message="Are you sure you want to delete this wall?"
        headingText="Delete Wall"
      />
      <ConfirmationModal
        isOpen={showItemsDeleteConfirmation}
        toggle={toggleShowItemsDeleteConfirmation}
        onConfirm={() => deleteSelectedItems(selectionManager.selections())}
        message={`Are you sure you want to delete ${
          selectionManager.selections().length
        } item${selectionManager.selections().length > 1 ? "s" : ""}`}
        headingText="Delete Items"
      />
      <ConfirmationModal
        isOpen={mergeShutterConfirmationOpen}
        toggle={toggleMergeShutterConfirmation}
        onConfirm={() => mergeSelectedShutter()}
        message="Are you sure you want to merge the selected shutters"
        headingText="Merge Shutters"
      />
      <ConfirmationModal
        isOpen={showMessageOnTemplateChange.show}
        toggle={() =>
          setShowMessageOnTemplateChange({ show: false, message: "", args: {} })
        }
        onConfirm={() => changeModuleTemplate(showMessageOnTemplateChange.args)}
        message={`${showMessageOnTemplateChange.message}`}
        headingText="Change Module"
      />
    </>
  );
}

export default NewPersonalize;
